webpackJsonp([1],{

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HgIx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc8f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("ZQhR")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2690a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("NZMO")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-ba2690a0"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36923708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("eJtY")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5139845f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("HgIx")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2b54d16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("tGyY")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/document.js


var _ref, _ref2;

/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "UEFA Direct - Issue 192",
  "shortTitle": "",
  "description": "",
  "width": 690,
  "height": 900,
  "currentLanguage": "EN",
  "languages": [{
    code: "EN",
    text: "English",
    href: "https://uefadirect.uefa.com/192/en"
  }, {
    code: "FR",
    text: "French",
    href: "https://uefadirect.uefa.com/192/fr"
  }, {
    code: "DE",
    text: "German",
    href: "https://uefadirect.uefa.com/192/de"
  }],
  "basePath": "/192/en",
  // "basePath": "",
  "companyLogo": "uefa-logo.png",
  "publishURL": "https://uefadirect.uefa.com/192/en/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": true,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 1-title\" style=\"top:781px; left:297px;\" src=\"/192/en/static/_content/1-title-1.png\">        \n        <img class=\"halfScaleC 1-logo\" style=\"top:-2px; left:566px;\" src=\"/192/en/static/_content/uefa-logo.png\">\n        <img class=\"halfScale 1-no\" style=\"top:107px; left:614px;\" src=\"/192/en/static/_content/1-sub-1.png\">\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-title\"), 0.6, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"1-logo\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.3\")\n          .fromTo(cOf(\"1-no\"), 0.6, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "No. 192  HOPE FOR THE FUTURE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 3-title\" style=\"top:307px; left:68px;\" src=\"/192/en/static/_content/3-title-1.png\">\n        <img class=\"halfScaleC 3-img\" style=\"top:14px; left:3px;\" src=\"/192/en/static/_content/3-img-1.png\">\n        <img class=\"halfScale 3-sub\" style=\"top:225px; left:78px;\" src=\"/192/en/static/_content/3-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg3Anim = new TimelineMax();\n          pg3Anim.fromTo(cOf(\"3-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"3-img\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.3\")\n          .fromTo(cOf(\"3-sub\"), 0.6, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg3Anim.stop();\n        }\n      ",
    "searchText": "EDITORIAL  Theodore Theodoridis UEFA general secretary  LEARNING LESSONS FROM A UNIQUE ACHIEVEMENT  T  he annals of European football history have been enriched by another momentous chapter. In less than two months, UEFA brought its 2019/20 club competitions to a successful conclusion by organising four tournaments in four different countries and staging the 2020 UEFA Super Cup match in Budapest. It is a unique achievement for any sports organisation. While none of us is likely to forget such an unprecedented season, we should take a moment to reflect on the achievement and draw lessons for the challenges that lie ahead. The success of the August tournaments can be attributed to several key factors. First and foremost, European football’s unity, solidarity and adaptability – UEFA, clubs, leagues and national associations joined forces in a genuine spirit of cooperation and compromise to draw up the match schedules in a remarkably short space of time. Moreover, the host associations staging the tournaments brought their invaluable organisational expertise to the table; the planning and operational measures put in place were effective and efficient; and the comprehensive health-related provisions and precautions that were necessary fully proved their worth. Last, but certainly not least, the teams and players who graced the field of play gave us much to savour in a series of exciting and dramatic encounters. Fans are the lifeblood of our sport, and it is a great shame that restrictions remain in force limiting the number of spectators at football matches. People’s health and safety is of paramount importance – but we must also recognise that, without fans, football loses something of its character. Consequently, UEFA decided to use the Super Cup match in Budapest as a pilot, allowing the match to be played with a reduced number of spectators – just 25% of the Puskás Aréna’s capacity to facilitate social distancing – in order to study precisely the impact of spectators on the UEFA Return to Play Protocol. To do this safely, we worked closely with the Hungarian government to protect the health of all those attending or participating in the match. We will now evaluate the health impact of the game, before deciding how to proceed further as far as UEFA’s matches are concerned. It is also our fervent hope, following the recent hectic schedule, that a more normal competition rhythm will now carry us through the coming months – while always bearing in mind that things are evolving constantly. One thing is certain, however – our recent experiences and challenges leave us better prepared to adapt and react to any circumstances and situations that may arise.  UEFA DIRECT • Q4 2020 – 03"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"halfScale 4-title-1\" style=\"top:130px; left:58px;\" src=\"/192/en/static/_content/4-title-1.png\">\n      <img class=\"halfScaleC 4-logo\" style=\"top:188px; left:21px;\" src=\"/192/en/static/_content/uefa-logo.png\">\n\n      <div class=\"addContentLink\" style=\"top:619px;left:203px;width:493px;height:64px\" onclick=\"Publish.goToPage(8)\"></div>\n      <div class=\"addContentLink\" style=\"top:702px;left:199px;width:233px;height:25px\" onclick=\"Publish.goToPage(19)\"></div>\n      <div class=\"addContentLink\" style=\"top:737px;left:199px;width:233px;height:47px\" onclick=\"Publish.goToPage(24)\"></div>\n      <div class=\"addContentLink\" style=\"top:797px;left:199px;width:233px;height:47px\" onclick=\"Publish.goToPage(32)\"></div>\n\n      <div class=\"addContentLink\" style=\"top:703px;left:437px;width:233px;height:47px\" onclick=\"Publish.goToPage(34)\"></div>\n      <div class=\"addContentLink\" style=\"top:761px;left:437px;width:233px;height:25px\" onclick=\"Publish.goToPage(37)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.fromTo(cOf(\"4-title-1\"), 0.6, {opacity:0, x:40}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n          .fromTo(cOf(\"4-logo\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "IN THIS ISSUE  Getty Images  CONTENTS  Q4 2020  Official publication of the Union of European Football Associations  Chief editor: Emmanuel Deconche Deputy chief editor: Dominique Maurer Chief writer: Mark Chaplin Subeditor: Susan Angel External contributors: Graham Turner (pages 26-31) Simon Hart (pages 32-33, 34-35) Translations: UEFA Language Services Production: Touchline Printing: Artgraphic Cavin, CH-1422 Grandson Editorial deadline: 25 September Cover photo: Getty Images  08 Competitions  After an enforced hiatus of nearly six months, the UEFA club competitions were eventually able to reach their conclusion.  19 Executive Committee 24 Development UEFA publishes the results of a study on training facilities and youth investment. Printed Matter myclimate.org/01-20-403670  32 Research Grant Programme Rahela Jurković has researched the links between football and refugees in the Balkans.  34 UEFA Grow The UEFA Grow programme starts up a finance management pillar.  37 News from member associations"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n\n      <div class=\"addContentLink\" style=\"top:393px;left:65px;width:397px;height:67px\" onclick=\"Publish.goToPage(26)\"></div>\n      <div class=\"addContentLink\" style=\"top:402px;left:461px;width:160px;height:63px;\" onclick=\"Publish.goToPage(20)\"></div>\n      <div class=\"addContentLink\" style=\"top:783px;left:67px;width:183px;height:59px\" onclick=\"Publish.goToPage(6)\"></div>\n      <div class=\"addContentLink\" style=\"top:788px;left:256px;width:440px;height:50px\" onclick=\"Publish.goToPage(18)\"></div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "20 Interview  26 The Technician  Executive Committee member and former footballing great Zbigniew Boniek talks to UEFA Direct.  For the UEFA president, Aleksander Čeferin, football needs to find a different approach to eliminate systemic racism from the game.  Getty Images  Getty Images  Getty Images  For 25 years now, UEFA has published technical reports on its competitions based on the conclusions of its technical observers.  06 Social responsibility  UEFA  Shutterstock  CONTENTS  18 UEFA Super Cup  In Budapest, Bayern Munich lifted the UEFA Super Cup for the second time.  UEFA DIRECT • Q4 2020 – 05"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 6-title\" style=\"top:556px; left:58px;\" src=\"/192/en/static/_content/6-title-1.png\">\n        <img class=\"halfScale 6-sub\" style=\"top:672px; left:58px;\" src=\"/192/en/static/_content/6-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim.fromTo(cOf(\"6-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"6-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n        }\n      ",
    "searchText": "‘A WAKE-UP CALL FOR SOCIETY AND THE WIDER EUROPEAN FOOTBALL COMMUNITY’ UEFA president Aleksander Čeferin explains why encouraging footballers to speak openly about their personal experiences of discrimination is a critical first step in rethinking UEFA’s efforts to eradicate racism from the European game.  T  he year 2020 has seen citizens around the world mobilise in response to two seismic events: first, to protect our families and communities from the global pandemic, then, to stand up for equal rights and justice for everyone. It has been a wake-up call, for society  06 – UEFA DIRECT • Q4 2020  and the wider European football community. It is a reality that billions of fans sometimes pay more attention to football than to their elected political leaders. In times of crisis, such enormous influence and reach bring added responsibility, and I am proud of the way European football has rallied to the sides  of local communities in their times of need. Since March, national associations, clubs and footballers across the continent have raised funds to purchase life-saving medical equipment, deliver food to the elderly and vulnerable, and helped public authorities spread critical health messages. It has been a reminder of football’s power"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 7-quote\" style=\"top:733px; left:72px;\" src=\"/192/en/static/_content/7-quote-1.png\">\n\n        <div class=\"addContentLink\" style=\"top:686px;left:453px;width:80px;height:12px;\">\n          <a href=\"https://www.uefa.com/insideuefa/video/0260-100ea96d11da-d249abf9eb5b-1000--kalidou-koulibaly-s-no-to-racism-message/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:686px;left:544px;width:62px;height:12px;\">\n          <a href=\"https://www.uefa.com/insideuefa/video/0260-100ea96d11da-d68b69305f4c-1000--nadia-nadim-s-no-to-racism-message/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim.fromTo(cOf(\"7-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg7Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "UEFA  Getty Images  SOCIAL RESPONSIBILITY  to communicate and connect with everyone, regardless of their colour, gender or beliefs. Similarly, clubs and players have shown solidarity with society’s outpouring of pain, anger and sadness following the tragic death of George Floyd in the United States. Athletes from a range of sports have spoken eloquently of a moment of genuine potential for governing bodies to rethink their anti-racism programmes.  change without concerted government action through national institutions such as schools. However, this cannot be an excuse to shirk football’s own responsibility. With 55 member associations and an audience of millions, UEFA is well placed to unite and coordinate fans, players, clubs, leagues, administrative bodies and the media. To slay the beast of racism, we will all need to stand and act together.  UEFA’s responsibility UEFA has always recognised its responsibility, both to address any form of racial bias within European football and take concrete steps to fight the sickening use of racist language against players. Off the pitch, we work hand in hand with non-governmental organisations like Football Against Racism in Europe (FARE) – a network that unites fan clubs, players’ unions, football associations and ethnic minority groups across Europe against racism and inequality. This collaboration shaped UEFA’s best practice guidelines for clubs and national associations on standing up to racism, including a ten-point plan of action that remains central to our overall mission to protect football. On the pitch, UEFA’s three-step rule gives officials the power to halt matches in the event of racist incidents. We have also used, and will continue to do so, the global visibility of our competitions to keep delivering our No to Racism message.  Understanding how racism really operates in sport As a first step in shaping a sea change in UEFA and European football’s approach, we need to build on footballers’ and fans’ recent vocalisation of feelings and frustrations long held in check for fear of a backlash. Not just to encourage an open debate about diversity and representation, but also to genuinely understand how racism permeates into different levels of football: from top to bottom, from boardrooms to training grounds for young footballers. It will not be comfortable listening, but we will not find a different solution without first identifying what doesn’t work now. This means encouraging individuals to keep talking openly about racism in football even when the topic is no longer headline news. As a sign of UEFA’s recognition of the need to listen and learn before building a new approach, we have invited several well-known players, past and present, to talk about their own first-hand experiences of racism – both as children and as professional footballers. Personally, I was struck by how early racism can start to taint a young boy’s or young girl’s footballing dream. Each of these players overcame discrimination to achieve their goals, but it left me wondering how many other potential Kalidou Koulibalys or Nadia Nadims lost their will to overcome stereotypical comments or judgements based on the colour of their skin, their nationality, their religion, sexual orientation or gender. It’s why many of the players come back to the same solution when sharing their personal perspective on where our sport should direct more time and resources to make a difference: using football’s popularity as a mass participation sport to educate families, communities, coaches and, above all, children.  Need to act together However, in the wake of recent events, it is clear that raising awareness alone is not enough. Together with the rest of European football, we need to lift our game and find a qualitatively different approach to eliminate systemic racism from our sport. Even for a governing body such as UEFA, it’s a tough challenge. Racism, discrimination – these attitudes are rooted in wider society and nothing will  ”With 55 member associations and an audience of millions, UEFA is well-placed to unite and coordinate fans, players, clubs, leagues, administrative bodies and the media. To slay the beast of racism, we will all need to stand and act together.” Aleksander Čeferin UEFA president  UEFA DIRECT • Q4 2020 – 07"
  }], [(_ref = {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": ""
  }, defineProperty_default()(_ref, "content", "\n      <img class=\"halfScale 8-title\" style=\"top:162px; left:59px;\" src=\"/192/en/static/_content/8-title-1.png\">\n      <img class=\"halfScale 8-sub\" style=\"top:243px; left:59px;\" src=\"/192/en/static/_content/8-sub-1.png\">\n      <img class=\"halfScale 8-sub\" style=\"top:500px; left:250px;\" src=\"/192/en/static/_content/8-quote-1.png\">\n      "), defineProperty_default()(_ref, "script", "\n      \n      function onPageEnter() {\n        pg8Anim = new TimelineMax();\n        pg8Anim.fromTo(cOf(\"8-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"8-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg8Anim.stop();\n      }\n      "), defineProperty_default()(_ref, "searchText", "GETTING THE GAME ON  Getty Images  UEFA’s club competitions returned in August with more than 40 matches being played across four countries, in four competitions, all within a four-week period. Just how did it all happen?  I  t was, first of all, extremely hectic these days, these months. We haven’t slept much. But in the end, it’s very important to do it… to show that football hasn’t stopped.” Those were the words of UEFA president Aleksander Čeferin as he reflected on the return of UEFA competitions in August. Rewind to mid-March, when competitions were put on hold and EURO 2020 was delayed by 12 months, and there would have been few people willing to believe that the UEFA Champions League, UEFA Europa League, UEFA Youth League and UEFA Women’s Champions League could be completed via a series of innovative and unique ‘final eight’ tournaments. Discussions began in May to consider what might be possible and what would be required to stage games at neutral venues. By the time the UEFA Executive Committee met on 17 June, three host associations had been identified as capable and willing to stage the special tournaments.  Everything was put in place in record time to bring the 2019/20 UEFA Champions League and UEFA Europa League to their conclusion in Portugal (Lisbon, above) and Germany (Cologne, right).  08 – UEFA DIRECT • Q4 2020  ‘‘As the luxury of time does not exist, quick planning [and] clear decisions must be made in partnership with the objective of delivering an event that seems to have been planned for years.’’ Daniel Ribeiro Portuguese Football Federation director  Getty Images  “"), _ref)], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "COMPETITIONS  protocol and its proper implementation by the clubs have further strengthened the confidence in the DFB.”  Getty Images  Getty Images  Barcelona’s Antoine Griezmann and Ousmane Dembélé arrive at the stadium for their team’s UEFA Champions League quarter-final.  Olympique Lyonnais and Bayern Munich get set for their UEFA Women’s Champions League quarter-final in Bilbao.  This was in addition to completing the Youth League at the Colovray stadium in Nyon, Switzerland, which usually hosts the semi-finals and final but this year saw usage of its facilities extended to the quarter-finals and one remaining round of 16 match. Picking the perfect partners Deciding to proceed with an ambitious plan is one thing, but pulling it off is quite another, and this is where collaboration and tireless planning alongside a range of key stakeholders proved invaluable. No partners were more important than the three national associations that hosted the senior club competition final eight tournaments – Germany, Portugal and Spain. In a typical year, planning for a senior UEFA club competition final will take 12 months. In 2020, they were organised in a little over two. Portuguese Football Federation (FPF) president Fernando Gomes identified what made Lisbon the ideal venue for Europe’s premier club competition final tournament. “The Champions League can happen in Portugal right away because we have clubs that invest in excellent infrastructures and  maintain them at a high level,” he explained. “Not only their stadiums, but also the training centres that will be so relevant in this unprecedented [final eight].” FPF director Daniel Ribeiro added: “As the luxury of time does not exist, quick planning [and] clear decisions must be made in partnership with the objective of delivering an event that seems to have been planned for years.” Germany was well placed to stage the Europa League given its early return to domestic action, high-class stadiums, suitable transport infrastructure, hotels and training facilities, and the North RhineWestphalia region was quickly identified as the perfect location, with enough venues to host the remaining matches in the competition. “We greatly appreciate being entrusted with this challenge and responsibility,” said German Football Association (DFB) president Fritz Keller. “UEFA’s decision reflects the high standing German football enjoys with the European football community. “I am positive we have the necessary infrastructure and experience to organise and stage a tournament of this dimension. In addition, our health and hygiene  A beacon of light Meanwhile, in Spain, the returning action offered hope to the wider female game. Only the German league had been completed to its original schedule, meaning that six of the eight UEFA Women’s Champions League finalists had gone several months without competitive matches by the time play resumed on 21 August. This was almost 300 days since the round of 16 was completed. Just as in Germany and Portugal, UEFA worked closely with the Royal Spanish Football Federation (RFEF) – no stranger to big events – to get the games on and identify two stadiums in close proximity with the facilities to stage matches in these unique circumstances. Collaboration with each of the teams, as well as the European Club Association (ECA), ensured that the tournament would work for the finalists. That included making it logistically possible for them to prepare and attend in their ‘bubbles’, as well as dealing with a season ending in August when key players’ contracts were expiring in June and transfers had already been agreed. Cooperation was the watchword to make sure that the flagship women’s club competition was able to go ahead safely. Bold and brave “It’s impossible to explain, but we are the only organisation in the world that organises four international events at the same time in four different countries,” said the UEFA president. “Not just the only sports organisation, but the only organisation at all. I think if you are bold enough and brave enough, you’ll succeed in the end, and it looks like our decision in the end was the right one.” A month of massive success, no doubt, with champions crowned and fans across the world entertained by the dramatic nature of the one-legged ties. But despite the positives, there is no time to rest. “It was not easy. We probably had some luck as well, but you have to know that they are not just four tournaments,” the UEFA president said. “We have club qualifiers for European competitions, we have started national team competitions at the beginning of September, so [we have] challenging times ahead as well.” UEFA DIRECT • Q4 2020 – 09"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 10-title\" style=\"top:129px; left:58px;\" src=\"/192/en/static/_content/10-title-1.png\">\n        <img class=\"halfScale 10-sub\" style=\"top:176px; left:58px;\" src=\"/192/en/static/_content/10-sub-1.png\">\n\n        <a href=\"https://www.uefa.tv/match/vod/162201/2030150\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:23px;left:134px;\" src=\"/192/en/static/_content/play.png\">\n        </a>\n\n        <div class=\"addContentLink\" style=\"top:44px;left:476px;width:84px;height:20px;\">\n          <a href=\"/192/en/static/_content/Champions-League_Fixture-List-Ranking-Table.pdf\" target=\"_blank\"></a>\n        </div>\n\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg10Anim = new TimelineMax();\n        pg10Anim.fromTo(cOf(\"10-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"10-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg10Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "BAYERN TAKE CENTRE STAGE After several anxious months, UEFA’s club competitions were able to resume in style in August with final tournaments in four countries. The 2019/20 UEFA Champions League reached its conclusion in a thrilling final eight in Lisbon that saw three clubs that have never won the title get into the semi-finals together with old hands Bayern Munich, who made their experience count.  Getty Images  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Getty Images  1 Thomas Müller up against Jason Denayer in the semi-final between Bayern and Lyon. 2 After their previous Champions League victory in 2013, Bayern (Manuel Neuer) have lifted the trophy for the second time.  Getty Images  2  3 Kingsley Coman came back to haunt his former club by scoring Bayern’s winning goal against PSG in the final.  3 UEFA DIRECT • Q4 2020 – 11"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Getty Images  5 6  4 Neymar in action for PSG against Leipzig in the semi-finals.  6 Manchester City’s Gabriel Jesus in action against Lyon in the quarter-finals.  Getty Images  5 Lyon had an impressive run to the semi-finals, knocking out both Juventus and Manchester City.  UEFA CHAMPIONS LEAGUE Quarter-finals (12–15 August) Manchester City FC - Olympique Lyonnais RB Leipzig - Club Atlético de Madrid FC Barcelona - FC Bayern München Atalanta BC - Paris Saint-Germain  1-3 2-1 2-8 1-2  (0-1) (0-0) (1-4) (1-0)  Semi-finals (18/19 August) RB Leipzig - Paris Saint-Germain Olympique Lyonnais - FC Bayern München  0-3 0-3  (0-2) (0-2)  Final (23 August) Paris Saint-Germain  0-1  (0-0)  - FC Bayern München  12 – UEFA DIRECT • Q4 2020  Getty Images  4"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 13-title\" style=\"top:126px; left:71px;\" src=\"/192/en/static/_content/13-title-1.png\">\n        <img class=\"halfScale 13-sub\" style=\"top:192px; left:71px;\" src=\"/192/en/static/_content/13-sub-1.png\">\n\n        <a href=\"https://www.uefa.tv/video/vod/163075/\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:45px;left:52px;\" src=\"/192/en/static/_content/play-green.png\">\n        </a>\n\n        <div class=\"addContentLink\" style=\"top:65px;left:450px;width:84px;height:20px;\">\n          <a href=\"/192/en/static/_content/Youth-League_Fixture-List-Ranking-Table.pdf\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg13Anim = new TimelineMax();\n        pg13Anim.fromTo(cOf(\"13-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"13-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg13Anim.stop();\n      }\n      ",
    "searchText": "Real Madrid’s next generation UEFA  Led by former great Raúl, Real Madrid won their first UEFA Youth League title in the final tournament played across the road from UEFA’s headquarters in Nyon, Switzerland.  2  1 Real Madrid captain Victor Chust lifts the UEFA Youth League trophy.  UEFA  2 Owing to the pandemic, Colovray stadium in Nyon also hosted the Youth League quarter-finals (Dinamo Zagreb v Benfica).  1 3  3 Real Madrid’s Óscar Aranda wins the ball away from Benfica’s Tiago Araújo in the final.  UEFA YOUTH LEAGUE Quarter-finals (18/19 August) FC Internazionale Milano - Real Madrid CF FC Salzburg - Olympique Lyonnais FC Midtjylland - AFC Ajax GNK Dinamo Zagreb - SL Benfica  0-3 4-3 1-3 1-3  (0-0) (2-1) (0-1) (1-1)  Semi-finals (22 August) SL Benfica FC Salzburg  - AFC Ajax - Real Madrid CF  3-0 1-2  (1-0) (0-2)  Final (25 August) SL Benfica  - Real Madrid CF  2-3  (0-2)  UEFA  UEFA DIRECT • Q4 2020 – 13"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 14-title\" style=\"top:763px; left:59px;\" src=\"/192/en/static/_content/14-title-1.png\">\n        <img class=\"halfScale 14-sub\" style=\"top:805px; left:58px;\" src=\"/192/en/static/_content/14-sub-1.png\">\n\n        <a href=\"https://www.uefa.tv/match/vod/162004/2030143\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:684px;left:93px;\" src=\"/192/en/static/_content/play-yellow.png\">\n        </a>\n\n        <div class=\"addContentLink\" style=\"top:808px;left:512px;width:84px;height:20px;\">\n          <a href=\"/192/en/static/_content/Europa-League_Fixture-List-Ranking-Table.pdf\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg14Anim = new TimelineMax();\n        pg14Anim.fromTo(cOf(\"14-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"14-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg14Anim.stop();\n      }\n      ",
    "searchText": "Sevilla do it again! In Cologne, Sevilla won their sixth UEFA Europa League title in as many finals.  14 – UEFA DIRECT • Q4 2020  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Getty Images  2  1 Sevilla’s Fernando in action in the final against Inter. 2 A familiar trophy presentation ceremony: Sevilla have won 40% of the last 15 UEFA Europa League/UEFA Cup competitions.  Getty Images  3 Paul Pogba (Manchester United) and Rasmus Falk (FC Copenhagen) in their teams’ quarter-final encounter, which Manchester United won 1-0 after extra time.  3 4  1-0  (0-0)  2-1 4-1 0-1  (2-1) (2-0) (0-0)  after extra time  Semi-finals (16/17 August) Sevilla FC FC Internazionale Milano  -  Manchester United FC FC Shakhtar Donetsk  2-1 5-0  (1-1) (1-0)  Final (21 August) Sevilla FC  -  FC Internazionale Milano  3-2  (2-2)  Getty Images  Getty Images  UEFA EUROPA LEAGUE Quarter-finals (10/11 August) Manchester United FC - FC Copenhagen 			 FC Internazionale Milano - Bayer 04 Leverkusen FC Shakhtar Donetsk - FC Basel 1893 Wolverhampton Wanderers FC - Sevilla FC  4 Owing to the pandemic, strict social distancing was the order of the day for interviews.  UEFA DIRECT • Q4 2020 – 15"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 16-title\" style=\"top:762px; left:58px;\" src=\"/192/en/static/_content/16-title-1.png\">\n      <img class=\"halfScale 16-sub\" style=\"top:793px; left:58px;\" src=\"/192/en/static/_content/16-sub-1.png\">\n\n      <a href=\"https://www.uefa.tv/video/vod/163148/?bucketName=2019%2F20%20SEASON%20REVIEW&section=UWCL\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:691px;left:106px;\" src=\"/192/en/static/_content/play-purple.png\">\n      </a>\n\n      <div class=\"addContentLink\" style=\"top:645px;left:336px;width:84px;height:20px;\">\n      <a href=\"/192/en/static/_content/Womens-CL_Fixture-List-Ranking-Table.pdf\" target=\"_blank\"></a>\n     </div>\n      ",
    "script": "\n      \n      function onPageEnter() {\n        pg16Anim = new TimelineMax();\n        pg16Anim.fromTo(cOf(\"16-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"16-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg16Anim.stop();\n      }\n      ",
    "searchText": "Getty Images  1  Unstoppable Olympique Lyonnais confirmed their dominance in Europe by winning their fifth UEFA Women’s Champions League in a row and their seventh altogether. 16 – UEFA DIRECT • Q4 2020  Getty Images  The roaring lionesses  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1 Record-breaking Olympique Lyonnais and their captain, Wendie Renard. 2 Turid Knaak (Atlético) up against Lieke Martens (Barcelona) at San Mamés Stadium in Bilbao in the all-Spanish quarter-final, won 1-0 by Barcelona.  Getty Images  3 Bayern’s Giulia Gwinn (left) and Lyon’s Sara Gunnarsdóttir in action in the quarter-finals at San Mamés Stadium.  3  0-1 2-1 1-9 1-2  (0-0) (1-0) (0-4) (1-1)  Semi-finals (25/26 August) Paris Saint-Germain - Olympique Lyonnais VfL Wolfsburg - FC Barcelona  0-1 1-0  (0-0) (0-0)  Final (30 August) VfL Wolfsburg  1-3  (0-2)  Getty Images  Quarter-finals (21/22 August) Club Atlético de Madrid - FC Barcelona Olympique Lyonnais - FC Bayern München Glasgow City FC - VfL Wolfsburg Arsenal Women FC - Paris Saint-Germain  4  - Olympique Lyonnais  4 Ewa Pajor (Wolsfburg) displays acrobatic prowess in her team’s semi-final against Barcelona at Anoeta Stadium in San Sebastián."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 18-title\" style=\"top:130px; left:58px;\" src=\"/192/en/static/_content/18-title-1.png\">\n        <img class=\"halfScale 18-sub\" style=\"top:246px; left:58px;\" src=\"/192/en/static/_content/18-sub-1.png\">\n\n        <a href=\"https://www.uefa.com/insideuefa/video/0259-0f842297fc14-2036bf494a63-1000--2020-uefa-super-cup-match-ball-designed-by-children/\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:774px;left:593px;\" src=\"/192/en/static/_content/play-purple.png\">\n        </a>\n\n        <div class=\"addContentLink\" style=\"top:768px;left:488px;width:132px;height:12px;\">\n          <a href=\"https://www.uefa.com/insideuefa/about-uefa/news/0261-1056d5baff3b-cb7369aab243-1000--children-design-match-ball/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:780px;left:440px;width:171px;height:12px;\">\n          <a href=\"https://www.uefa.com/insideuefa/about-uefa/news/0261-1056d5baff3b-cb7369aab243-1000--children-design-match-ball/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:792px;left:440px;width:159px;height:12px;\">\n          <a href=\"https://www.uefa.com/insideuefa/about-uefa/news/0261-1056d5baff3b-cb7369aab243-1000--children-design-match-ball/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:804px;left:440px;width:153px;height:12px;\">\n          <a href=\"https://www.uefa.com/insideuefa/about-uefa/news/0261-1056d5baff3b-cb7369aab243-1000--children-design-match-ball/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:816px;left:440px;width:159px;height:12px;\">\n        <a href=\"https://www.uefa.com/insideuefa/about-uefa/news/0261-1056d5baff3b-cb7369aab243-1000--children-design-match-ball/\" target=\"_blank\"></a>\n      </div>\n        <div class=\"addContentLink\" style=\"top:828px;left:440px;width:72px;height:12px;\">\n        <a href=\"https://www.uefa.com/insideuefa/about-uefa/news/0261-1056d5baff3b-cb7369aab243-1000--children-design-match-ball/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg18Anim = new TimelineMax();\n        pg18Anim.fromTo(cOf(\"18-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        .staggerFromTo(cOf(\"18-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n      }\n\n      function onPageLeave() {\n        pg18Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "BAYERN TRIUMPHANT IN BUDAPEST  Getty Images  Played less than four weeks after the conclusion of the 2019/20 football season, the UEFA Super Cup, European football’s traditional curtain-raiser, was always going to be different – but the biggest change offered football fans a rare glimpse of normality.  F  or the first time since its competitions were put on hold in March, UEFA allowed a reduced number of fans to watch Champions League winners FC Bayern München take on Europa League counterparts Sevilla FC in Budapest’s Puskás Aréna on 24 September. Attendees also included 500 local health workers, guests of the Hungarian Football Federation (MLSZ) in recognition of their frontline role in the pandemic. If the 15,500 spectators looked thinly spread across the stadium’s 60,000 seats, that was the intention. Limiting the number of fans to 25% of the total capacity facilitated the maintenance of social distancing rules. Run as a pilot project to assess the impact of fans on UEFA’s Return to Play medical and operational protocol, European football’s governing body and the MLSZ took extensive precautions to prevent infection. Thermal scans checked body temperatures at outer perimeter entry points, fans were instructed to wear a mask when unable to keep to the 18 – UEFA DIRECT • Q4 2020  recommended distance and to use specially marked queuing lanes at turnstiles and food stalls. Speaking on the day of the game, UEFA president Aleksander Čeferin said: “Health is our number one priority, but we want to bring hope, we want to do what we think is the proper thing to do. The easier thing for us would be to not do anything but then nothing moves.” On the pitch, all-conquering Bayern were definitely on the move, picking up their fourth trophy of 2020. Sevilla more than played their part, though, taking an early lead before the German champions drew level just before the break. After missing several chances to convert territorial dominance into goals, Bayern substitute Javi Martínez headed the winner in extra time. It was his team’s 12th consecutive European victory and the 25th time in 45 editions that the holders of the continental crown have claimed the Super Cup. The Super Cup venue switched to Budapest as part of the rearrangement of the football calendar in June. The MLSZ  hopes the impact of hosting football’s top stars in the magnificent setting of the Puskás Aréna will stretch far beyond the capital city, adding momentum to its efforts to inspire a new generation of Hungarian youngers. As part of its goal to ensure that no Hungarian citizen lives more than ten kilometres from a quality pitch, the MLSZ has built or renewed almost 3,000 football pitches in the past ten years. Over the same period, the number of registered grassroots players has grown threefold to almost 300,000, including 30,000 girls. The Super Cup’s pre-match ceremony has become synonymous with children in recent seasons. While the UEFA Foundation for Children event was not possible in the current circumstances, football’s youngest fans still left their mark on the event – in particular, the official match ball. Schoolchildren had been asked to produce designs for the official match ball in a Europe-wide competition run by the foundation, with ten winning drawings taking pride of place on the finished product."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 19-title\" style=\"top:129px; left:71px;\" src=\"/192/en/static/_content/19-title-1.png\">\n        <img class=\"halfScale 19-sub\" style=\"top:214px; left:71px;\" src=\"/192/en/static/_content/19-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax();\n          pg19Anim.fromTo(cOf(\"19-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"19-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg19Anim.stop();\n        }\n      ",
    "searchText": "EXECUTIVE COMMITTEE  CALENDAR CHANGES AND SPECIAL MEASURES At its latest meeting in Budapest on 24 September, the UEFA Executive Committee took various decisions and introduced a series of measures and rules to take account of the current situation.  F  ollowing an agreement with the European Club Association and the European Leagues, the committee decided to recover dates lost through the cancellation of the March 2020 window and the postponement of EURO 2020 to next summer, both as a result of the COVID-19 pandemic. The March/ September 2021 FIFA international match calendar windows will be extended to accommodate three matches instead of two.  Revised calendar for European national team matches (pending FIFA's approval) 22–31 March 2021: three dates 31 May – 8 June 2021: EURO preparation friendly matches 30 August – 8 September 2021: three dates 4–12 October 2021: two dates 8–16 November 2021: two dates 21–29 March 2022: two dates for European Qualifiers play-offs The UEFA Nations League finals will be played in October 2021, featuring semi-finals (6/7 October) and the third-place play-off and final (10 October). Three Group 1 associations – Italy, the Netherlands and Poland – have expressed interest in hosting the finals.  UEFA Women’s Champions League – thereby easing the burden on players caused by the condensed 2020/21 international match calendar. The procedure to establish European Qualifiers fixtures for the 2022 FIFA World Cup was ratified, taking into account aspects such as winter venues, travel distance, home-and-away sequence and the number of teams per group.  competition regulations were approved along with match organisation rules clarifying the process, consequences and responsibility in the event of travel restrictions or positive COVID-19 tests. The 2020/21 UEFA Youth League will also have a new format, given existing difficulties in organising the competition in the current circumstances. Straight knockout matches will start from the round of 64, beginning in March 2021.  Special rules In light of COVID-19, special measures were approved to regulate the play-offs to complete the EURO 2020 field. Special rules were also ratified for match organisation in the UEFA Champions League and UEFA Europa League group stages. With a new format and calendar in place for the 2020/21 UEFA Women’s Champions League, the revised  All UEFA meetings in Switzerland Finally, the committee decided that, on account of current restrictions, Switzerland will host all corporate UEFA meetings in the next six months to reduce UEFA’s organisational burden. This applies in particular to the coming Executive Committee meetings in December and March, as well as the Ordinary UEFA Congress in March 2021.  The Executive Committee decided to allow up to five substitutions in UEFA competitions until the end of the current season.  Getty Images  Five substitutions Up to five substitutions will be permitted for all matches for the remainder of the season in the UEFA Nations League, European Qualifiers play-offs, UEFA Women’s EURO qualifiers, UEFA Champions League and UEFA Europa League (group stage onwards) and the  UEFA DIRECT • Q4 2020 – 19"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 20-title\" style=\"top:166px; left:64px;\" src=\"/192/en/static/_content/20-title-1.png\">\n        <img class=\"halfScale 20-sub\" style=\"top:281px; left:64px;\" src=\"/192/en/static/_content/20-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.fromTo(cOf(\"20-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"20-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg20Anim.stop();\n        }\n      ",
    "searchText": "INTERVIEW  ZBIGNIEW BONIEK  ‘IN FOOTBALL, TALENT IS OFTEN MORE OF A HINDRANCE THAN A HELP‘ There were few better sights in football than to watch Zbigniew ‘Zibi‘ Boniek in full flow on the field – especially on magical European nights in the 1980s when he was helping Juventus conquer the continent’s footballing summits. His pace, acceleration, technique and goalscoring powers, especially under floodlights, earned him the nickname ‘Bello di notte’ (Beauty at night) from Juventus president Gianni Agnelli.  B  PresseSports  orn in Bydgoszcz in Poland, Boniek first played for his home club Zawisza Bydgoszcz before moving to Widzew Łódź, where he won two Polish titles. He was transferred to Italian football giants Juventus in 1982, where he became a mainstay of a splendid Bianconeri team that won the European Cup Winners' Cup and UEFA Super Cup in 1984, followed by the European Champion Clubs’ Cup in 1985. He ended his playing career with AS Roma in 1988. Boniek made his Polish national team debut at the age of 20 and played in the 1978, 1982 and 1986 World Cup finals, shining brightest in 1982 in Spain, where he scored a hat-trick against Belgium as Poland went on to finish third. He scored 24 goals in 80 games for his country. Having coached US Lecce and AS Bari among others in Italy, Boniek served as vice-president of the Polish Football Federation (PZPN) from 1999 to 2002, when he briefly coached the national team. He was elected president of the PZPN in October 2012, and was elected to the UEFA Executive Committee as a member at the Helsinki Congress in April 2017. In this interview, UEFA Direct talks  football with Boniek – his playing career, his views on the game and taking the step from being an icon as a footballer to giving back to his country’s football as the man at the political helm…  experience. In Poland, we started out again by playing matches behind closed doors, but from mid-June games were open to the public, with a stadium capacity limit of 25%; from the end of July it has been 50%.  Zbigniew Boniek, how has Poland, and more specifically Polish football, dealt with the COVID-19 crisis? It was obviously a shock for everyone, and we had to live through difficult times. However, because various services were closed down immediately, we came through the period pretty well. It’s clear that football suffered as well, but we were pleased that we were able to start again relatively quickly.  Let's move on to your life in football... Had you been a fan since you were a child? Yes… I've always been a great fan of football, and I loved watching everything. I always played football in the street. One of my first clear memories of football is of being seven years old and watching a Division B match that my father was playing in.  Matches across Europe are being played behind closed doors without spectators as a precautionary measure. Did you ever play in a professional match behind closed doors in an empty stadium? Yes, I've played behind closed doors, and I have to say that it wasn’t the nicest  As a young player, Zbigniew Boniek admired German midfielder Günter Netzer.  Did you have a favourite player when you were young? I adored the great Poland striker Włodzimierz Lubański when I was small. Then, when I got older, I really admired the German midfield player Günter Netzer. When I started to play, I no longer looked up to any icons. You enjoyed a great career as a player at the highest levels. What do you think that your strengths were as a player? It's always hard to talk about oneself, but I do believe I had a good career. I think I was an ‘all-rounder’ as a player. I’d rather not say anything else – I think it’s up to players who played against me and marked me to say more!"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "UEFA  INTERVIEW  UEFA DIRECT • Q4 2020 – 21"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 22-quote\" style=\"top:150px; left:79px;\" src=\"/192/en/static/_content/22-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.fromTo(cOf(\"22-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop();\n        }\n      ",
    "searchText": "INTERVIEW  What would you have done in life if you hadn't become a footballer? I got my degree in physical education before I left Poland. I think I could have taught PE in schools, been a coach... I think I certainly would have done something to do with sport and football, anyway. Is there one particular match that stands out for you in your memory? Yes, more than one. Quite certainly the play-off against France in Alicante in the 1982 World Cup, which Poland won 3-2 to clinch third place – and, unfortunately for other reasons, the Heysel Stadium disaster at the Champion Clubs’ Cup final in Brussels in 1985.  UEFA  “I can say that I'm happy to have led the Polish Football Federation for eight years – because thanks to my work, and that of the people who have worked with me, we have changed and improved football in Poland.”  Boniek up against Phil Neal in the 1984 UEFA Super Cup against Liverpool, which Juventus won 2-0, with both goals coming from Boniek himself.  What about a goal that you have scored? I’d say two goals – the two that I scored for Juventus in the 1984 UEFA Super Cup match against Liverpool.  Who is the best player that you have played with and against? The best player I played with was Michel Platini, when we were together at Juventus – and the best player I played against was Diego Maradona, who played in Italy for Napoli. How much has the game changed since you were a player? A lot, because the rules have changed. 22 – UEFA DIRECT • Q4 2020  Getty Images  How important is talent for success? And hard work? I feel that talent is important, but it's often more of a hindrance than a help; players are very pampered, they are carried, and the money starts to come in very early on – and this could lead to talent being wasted. The ideal player is one that has talent but who, above all, works very hard."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "How did you get involved in the administrative side of the game? Did you ever imagine during your career as a player that one day you would be at the helm of the national football association in your country? Well, when you're young, you don't really think about those things! But I can say that I'm happy to have led the Polish Football Federation for eight years – because thanks to my work, and that of the people who have worked with me, we have changed and improved football in Poland. Has having been a renowned player and a Polish icon helped you in your role as PZPN president? Did you receive a kind of automatic respect? Or did you have to work to earn respect ‘again’? Having a glorious past helps, and when you knock, everyone opens the door – but once it's open, you need to show that you have something to give, because otherwise the past doesn't count for anything. It must be a rewarding and exciting position being the president of your association. What attributes must a president have in order to be successful? They must understand football, know how to manage such an important workforce and know how to behave and deal with other people; these are some of the factors that help you to be a good president.  How important is UEFA’s help to Poland, in particular through the HatTrick programme? I've nothing but thanks for UEFA, because it has given us the chance to organise so many events in the last eight to ten years. Also, thanks to HatTrick, we have been able to develop grassroots and youth football. How proud are you of contributing to the development of UEFA as a member of UEFA's Executive Committee? How do you see UEFA's ongoing progress as the umbrella body for European football? I'm really pleased to be a member of the Executive Committee, and I'm always trying to suggest something, because I've got a great deal of experience in the field. I've found some really effective professionals within the committee, and I feel comfortable together with them. How important do you think values like respect and fair play are in football? They are fundamental! What do you think is the greatest danger football is facing nowadays?  The one match that stands out in Boniek's memory is Poland's third-place play-off win against France in the 1982 World Cup.  There is no simple answer. Perhaps the costs of maintaining a club are too high – and this could then widen the gap between the major European clubs and other clubs. If you had a footballing wish for the future, what would it be? To be 20 again – and to be able to start my career once more! Poland has qualified for the next EURO. What is your opinion on Robert Lewandowski and the current squad? Will they go far in the tournament next year? There is a saying in Italy – ‘slow and steady wins the race’. I prefer to surprise people with my national squad, rather than talking about the role of the favourite player. But it's a strong team, a team that is very capable… and Lewandowski is an exceptional player. Finally, what would be your advice for a young boy who is dreaming about a career as a footballer? Have fun for as long as possible and don't think about football as something that will be a life solution. The only aim is to enjoy it day by day – and then if you're good, all will be revealed…  Getty Images  You left Poland to play abroad, and you made your mark with Juventus in Italy. How did that experience help you to grow as a player and as a person? When I arrived at Juventus, I was already mature as a player, but I still learned a lot, and I think my teammates learned a lot from me as well. I grew as a person too, but I was prepared for it and never had any difficulties.  Getty Images  For example, in my time, if the defender stopped a player going through on goal, he wasn't penalised. The game is much faster, too, and play is very tight between midfield and defence. There is no point in making a comparison – but I would say that if the Juventus team I played in played against any other team now, I don’t think we would be at a disadvantage.  Boniek's name stood out at the 1982 World Cup."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 24-title\" style=\"top:129px; left:58px;\" src=\"/192/en/static/_content/24-title-1.png\">\n        <img class=\"halfScale 24-sub\" style=\"top:247px; left:58px;\" src=\"/192/en/static/_content/24-sub-1.png\">\n\n        <div class=\"addContentLink\" style=\"top:332px;left:268px;width:374px;height:500px;\">\n        <a href=\"https://editorial.uefa.com/resources/0261-10556abc5df0-d5da90ab290e-1000/uefa_tfyi_report_2020_5_.pdf\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.fromTo(cOf(\"24-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"24-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg24Anim.stop();\n        }\n      ",
    "searchText": "DEVELOPMENT  STUDY RESULTS ON TRAINING FACILITIES AND YOUTH INVESTMENT ACROSS EUROPE UEFA solidarity payments to clubs, which in the last decade exceeded €1 billion, form a major part of youth development budgets. A new report offers unique insight into how clubs use those payments for their long-term development and sustainability.  U  EFA recently released a brand-new interactive report offering unique insight into training facilities and youth investment in Europe. With the impact of the COVID-19 pandemic casting an uncertain future over football finances, high-quality youth development and infrastructure investment to support player development is arguably more important than ever. The UEFA Training Facility and Youth Investment Landscape presents a comprehensive overview of 950 training facilities used by 673 clubs across Europe, using information gathered by UEFA’s intelligence centre over the past year. Additionally, the report provides insight into youth player development and youth investment by top-division clubs, partly financed by UEFA via club solidarity payments, as well as a country by country overview giving localised learnings for clubs, media and supporters. Key findings • Total estimated annual youth development budget of European top-division clubs in 2020 is €870m. • Total solidarity payments distributed to non-UEFA competition participants for youth development in the last decade exceeded €1bn and on an annual basis has more than tripled in the last ten years, from €43m in 2008/09 to €139m in 2018/19. • 1,629 different clubs have received UEFA solidarity funds in the last decade. • 53 top-tier clubs (in 33 different countries) have inaugurated new training centres in the last two years, with at least a further 27 currently in development. • Investment by European top-division clubs in training facilities over the last five years amounted to more than €1bn. • 76% of the clubs with a women’s team use the same facility for both the men’s and women’s teams.  24 – UEFA DIRECT • Q4 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"25-no1\" class=\"abs frutigerUB 25-no\" style=\"left:360px;top:184px; font-size: 1.3em; font-weight:300; margin:0; color:white; padding:0; margin:0;\"  data-number='{\"to\": 1629, \"comma\": true}' ></h1>\n        <h1 id=\"25-no1\" class=\"abs frutigerUB 25-no\" style=\"left:526px;top:184px; font-size: 1.3em; font-weight:300; margin:0; color:white; padding:0; margin:0;\"  data-number='{\"to\": 1, \"append\": \"bn\", \"preppend\": \">\u20AC\"}' ></h1>\n        <h1 id=\"25-no1\" class=\"abs frutigerUB 25-no\" style=\"left:366px;top:336px; font-size: 1.3em; font-weight:300; margin:0; color:white; padding:0; margin:0;\"  data-number='{\"to\": 76, \"append\": \"%\"}' ></h1>\n        <h1 id=\"25-no1\" class=\"abs frutigerUB 25-no\" style=\"left:551px;top:336px; font-size: 1.3em; font-weight:300; margin:0; color:white; padding:0; margin:0;\"  data-number='{\"to\": 53, \"append\": \"\"}' ></h1>\n\n        <div class=\"abs\" style=\"bottom:98px;left:341px;height:268px;width:300px;overflow:hidden\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:0px;transform-origin:bottom left\" src=\"/192/en/static/_content/25-bar-1.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:30px;transform-origin:bottom left\" src=\"/192/en/static/_content/25-bar-2.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:56px;transform-origin:bottom left\" src=\"/192/en/static/_content/25-bar-3.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:84px;transform-origin:bottom left\" src=\"/192/en/static/_content/25-bar-4.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:112px;transform-origin:bottom left\" src=\"/192/en/static/_content/25-bar-5.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:140px;transform-origin:bottom left\" src=\"/192/en/static/_content/25-bar-6.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:168px;transform-origin:bottom left\" src=\"/192/en/static/_content/25-bar-7.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:196px;transform-origin:bottom left\" src=\"/192/en/static/_content/25-bar-8.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:224px;transform-origin:bottom left\" src=\"/192/en/static/_content/25-bar-9.png\">\n          <img class=\"halfScale 25-bar abs\" style=\"bottom:0; left:252px;transform-origin:bottom left\" src=\"/192/en/static/_content/25-bar-10.png\">\n        </div>\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg25Anim = new TimelineMax();\n        pg25Anim.fromTo(cOf(\"25-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[0]);}}, 1)\n        .fromTo(cOf(\"25-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[1]);}}, \"+=0.3\")\n        .fromTo(cOf(\"25-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[2]);}}, \"+=0.3\")\n        .fromTo(cOf(\"25-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"25-no\")[3]);}}, \"+=0.3\")\n        .staggerFromTo(cOf(\"25-bar\"), 1, {y: \"100%\"}, {y: \"0%\", ease: Power2.easeOut}, 0.1, \"+=0.3\")\n      }\n\n      function onPageLeave() {\n        pg25Anim.stop()\n        removeContentLinks()\n        resetNumbers(\"25-no\")\n      }\n      ",
    "searchText": "DEVELOPMENT  KEY FINDINGS FC FC  Raising standards One of UEFA’s key roles as European football’s governing body is to help raise standards on and off the pitch. Training facilities and youth academies represent the very core of the European football ecosystem – even more so in the light of the COVID-19 pandemic and the impact it is having on football institutions. With the integration FC of more developed training infrastructure requirements in the 2018 UEFA Club Licensing and Fair Play Regulations, the importance of these two components has been further emphasised. This new report presents a first overview of the picture across Europe, where specific needs and resources vary between national associations, following the introduction of the updated licensing requirements. Solidarity funding for youth development UEFA’s solidarity payments, made to clubs not competing in UEFA club competitions, represent the second-largest funding source for training centres and youth development. Payments are distributed for investment in youth development programmes and local community schemes, making up an estimated 19% of youth development budgets across Europe’s top-division clubs.  1,629  >€1bn  different clubs have received UEFA solidarity funds in the last decade.  Investment by European top-division clubs in training facilities over the last five years.  FC  FC FC  76%  of the clubs with a women’s team use the same facility for both the men’s and women’s teams.  53  top-tier clubs (in 33 different countries) have inaugurated new training centres in the last two years, with at least a further 27 currently in development.  Top-division clubs across FC Europe currently invest a total of €870m a year in youth FC development. The top ten countries by average club budget (€m) are: 6.1m 5.3m  Variation across the landscape The report highlights the way in which this funding is spent differs between associations. For example, because of their climate, clubs in Finland, Norway, Russia and Sweden tend to use artificial/hybrid pitches at their training grounds, while Danish clubs possess, on average, the highest number of training pitches – attributable to the fact that all top-level clubs in Denmark have direct links between their grassroots sections and their senior teams. While investment in training facilities varies between clubs, the average club amount dedicated in the last five years in Germany, Hungary, Spain and Switzerland stands at more than €5m. This demonstrates clubs’ commitment to long-term development and sustainability in their operating strategies. In Bosnia and Herzegovina, Croatia, Denmark, the Faroe Islands, Finland, Hungary, Iceland and Scotland, all top-division clubs have upgraded their facilities in the last decade.  4.7m  4.6m  3.4m 2.8m  2.7m 1.9m 1.8m  1.7m  UEFA DIRECT • Q4 2020 – 25"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 26-title\" style=\"top:497px; left:58px;\" src=\"/192/en/static/_content/26-title-1.png\">\n        <img class=\"halfScale 26-sub\" style=\"top:576px; left:58px;\" src=\"/192/en/static/_content/26-sub-1.png\">\n\n        <div class=\"addContentLink\" style=\"top:152px;left:51px;width:112px;height:32px;\">\n          <a href=\"http://www.uefatechnicalreports.com/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim.fromTo(cOf(\"26-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"26-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg26Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "THE TECHNICIAN  THE COACHING CASCADE Over the last 25 seasons, UEFA has published more than 130 technical reports on its club and national team competitions, based on input from top coaches who have acted as technical observers. If put together as a compendium, the reports add up to a technical/tactical legacy and provide a fascinating insight into the evolution of the European game over the last quarter-century.  XX – UEFA DIRECT • Juillet/Août 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 27-quote\" style=\"top:677px; left:469px;\" src=\"/192/en/static/_content/27-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax();\n          pg27Anim.fromTo(cOf(\"27-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg27Anim.stop();\n        }\n      ",
    "searchText": "THE TECHNICIAN  A  As a random symptom of the game’s evolution, eight of the participants at that first 16-team final tournament implemented man-marking and operated with a libero – a role which, as subsequent technical reports have traced, has been handed to goalkeepers, whose ability with the feet has steadily gained relevance and permeated UEFA’s age-limit tournaments – to the extent that the technical report on the 2015 European Under-21 finals pointed out that goalkeeper Marc André ter Stegen had, in many matches, delivered more passes than any other German player. The way to success “Over the years”, Hodgson reflects, “the technical reports have tried to pinpoint the aspects that were helping to make teams successful. Athletic qualities have evolved; formations have gone through 4-4-2 or three-at-the-back periods. And there have been knock-on benefits. For example, the technical reports on the EUROs, the Champions League and the Europa League are really useful to spark discussion when UEFA gets the top coaches together for the Elite Club Coaches Forum or a national coaches conference, and a lot of ideas have been implemented. Another thing I’d like to emphasise is that, while financial and marketing aspects of the game were evolving really quickly, the technical side was not very well covered. So the technical reports have been positive in highlighting the coaching aspects of the game.” “It doesn’t require an eagle’s eye to spot that all our technical reports relate to national teams. Then we realised that it was incongruous to overlook Europe’s premier club competition.” Those were  ‘‘The role is about producing a technical report that serves the purpose of passing on observations to people who are not so close to the tournament or might not have the same level of expert knowledge.’’ Sportsfile  Shutterstock  sking readers to define the role of UEFA’s technical observers might invite a few picturesque answers. Whereas ‘referee observer’ is a label that can be clearly read, UEFA’s menu of FAQ could easily include ‘What does a technical observer observe?’ or even ‘What exactly is a technical report?’ The most concise response to both queries would be ‘they analyse the proceedings from a coaching perspective’ even though, these days, the role has expanded beyond tactical analysis to embrace the tasks of selecting MVPs, team and player of the tournament, best goals and, in the two major men’s UEFA club competitions, a goal of the week. Although members of the Technical Committee had previously contributed to tournament reviews, UEFA technical reports really kicked off at EURO ‘96 when UEFA covered coaching aspects of the tournament in England with a team of five observers: Gérard Houllier, Daniel Jeandupeux, Rinus Michels, Tommy Svensson and Roy Hodgson. The former Switzerland and England national team manager, currently at the helm at Crystal Palace, reminisces: “It was a good group of observers and we took the role very seriously, trying to pick out the most relevant aspects and make sense of what we were seeing. And, basically, the role hasn’t changed that much over the years. It’s still about producing a technical report that serves the purpose of passing on observations to people who are not so close to the tournament or might not have the same level of expert knowledge. With all due modesty, I think we did that successfully, offering analytical information and useful insights. I thought it was a very, very positive thing to do.”  Roy Hodgson Former Switzerland and England national coach  UEFA DIRECT • Q4 2020 – 27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 28-quote\" style=\"top:225px; left:382px;\" src=\"/192/en/static/_content/28-quote-1.png\">\n        <img class=\"halfScale 28-quote\" style=\"top:587px; left:74px;\" src=\"/192/en/static/_content/28-quote-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim.staggerFromTo(cOf(\"28-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n        }\n      ",
    "searchText": "THE TECHNICIAN  ‘‘The most rewarding thing is to discuss so many things with a group of football people who have different opinions and ways of seeing things.’’  Sportsfile  Getty Images  David Moyes UEFA technical observer  ‘‘Observing UEFA youth finals has helped identify trends, see promising talent and relate this back to toplevel senior football.’’ John Peacock UEFA technical observer  the words of former UEFA president Lennart Johansson in his preface to the first UEFA Champions League report, which appeared after Manchester United’s epic victory over FC Bayern München in Barcelona in 1999. During the first decade of the new millennium, coverage of age-limit tournaments gathered momentum – as did the competitions themselves. 30 – UEFA DIRECT • Q4 2020  Technical reports on the UEFA Europa League appeared soon after its metamorphosis from the old UEFA Cup, and, these days, technical observers are on squad lists for the full spectrum of UEFA’s club and national team competitions. Reporting on the club competitions is a different ball game. With fixtures dotted all over the map, technical observers become  lone wolves who report on individual matches and only meet their colleagues at the final – a scenario that generates challenges in terms of collating material and detecting overall trends. By contrast, a final tournament allows observers to strike sparks off each other on a daily basis – an aspect of the job they relish. David Moyes, technical observer at EURO 2016 and the 2019 UEFA Nations League finals, as well as for UEFA Champions League matches, comments: “The most rewarding thing is to discuss so many things with a group of football people who have different opinions and ways of seeing things. For example, everybody likes to discuss topics like change-footed wingers and the impact they have on your attacking patterns. It’s really good to be part of that and I’ve brought information and ideas back from both the EURO and the Nations League. And I think the ideas you get from watching the amazing coaching at top level can be exploited all the way down to junior teams.” From the top to the bottom Cascading information from the top to the bottom of the game is the raison d’être of the technical report. John Peacock, champion of Europe with England’s Under-17s and a regular UEFA technical observer, comments: “As someone who has been fortunate to manage national development teams and oversee coach education in England, I always found the role of technical observer complemented that really well. You can bring back the findings and use the skills acquired in both domains. Observing UEFA youth finals has helped identify trends, see promising talent and relate this back to toplevel senior football. And tournament football"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 29-quote\" style=\"top:313px; left:278px;\" src=\"/192/en/static/_content/29-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim.fromTo(cOf(\"29-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop();\n        }\n      ",
    "searchText": "is different – effectively managing a number of games over a short period is a skill. I like to observe how teams and coaches overcome this issue and balance results against development while giving young players opportunities to showcase themselves within a pressure situation. If we relate this to coach education it takes into account all aspects of technical/tactical, physical, psychological and social components – all the major ingredients for a top player or coach.” It could easily be argued that cascading information via the technical reports has had even greater relevance in the fast-growth sectors of women’s football and futsal. Sweden’s Anna Signeul, a long-standing technical observer currently in charge of the Finland women’s national team (and the coach who led Scotland to a first-ever final tournament appearance at Women’s EURO 2017) feels the technical reports have been “important for many reasons. As a historical tool for the development of the game by plotting trends and developments. As a learning tool for everyone working in the game at senior and youth levels and as an educational tool to stimulate discussion and catalyse analysis and debate, as well as  UEFA  THE TECHNICIAN  ‘‘As an observer, a EURO is a huge learning experience and I felt that EURO 2013, when it was expanded to 12 teams, was a great step forward.” Anna Signeul Finland women’s national team coach  promoting further investment into the game. As an observer, a EURO is a huge learning experience and I felt that EURO 2013, when it was expanded to 12 teams, was a great step forward.” Her sentiment is echoed by Finland’s Jarmo Matikainen, UEFA’s record holder in coverage of men’s and women’s competitions when his duties with the national teams of Finland, Wales, Canada and (currently) Estonia have permitted. “Witnessing the growth and development at that tournament was inspirational and our group of technical observers was very forward-thinking. The mindset was always about improving technical reports and making them better for all coaches to use.” Hope Powell, regular technical observer and EURO silver medallist as manager of England in 2009, comments: “I like to believe that the reports have contributed to the development of the game and I hope that aspiring as well as seasoned coaches get insights so that knowledge can be shared from a coach education standpoint. As an observer, it makes me continually wonder what I would do in that particular situation – it challenges my thinking!”  From pens to tablets  These days, this has evolved into advanced image processing technology to capture and deliver (at a high-resolution data rate of 25 points per second) realtime tracking data on the movements of each player, the referees and the ball. This makes performance data, such as distance run, speed, acceleration, stamina, team formations and set plays instantly available for playby-play video analysis and graphical visualisations – all of which gives added value to the technical reports. In other competitions, such as the men’s and women’s  age-limit tournaments, the technical observers’ impressions are supported – or even shaped – by data gathering based on a trio of analysts using bespoke software that overlays a live video feed on a pitch graphic. Each team is monitored by one person, while the third operates in a data-checking role. Using a combination of hot keys and mouse clicks, they track who is on the ball and what happens to it, with each match yielding between 1,600 and 2,000 individual pieces of data. For the technical observers, match coverage has been  Sportsfile  Way back in 2006, benchmarks were laid in the UEFA Champions League with the introduction of tracking technology based on two banks of cameras installed high in the stands.  a story of transition from pens and notepads to tablets and tagging apps that allow the observer to make notes on the match electronically and highlight key moments. Post-match, the tags are then synced to the video, enabling them to view the tags or video clips while writing  their match report. They can also use a smartphone or smartwatch to tag key moments. Today’s observer can also have access to a tactical view of the match – a wide-angle capture from a vantage point that gives the best view of team shapes and tactical patterns.  UEFA DIRECT UEFA• March/April DIRECT • Q4 2020 – 29"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 30-quote\" style=\"top:282px; left:58px;\" src=\"/192/en/static/_content/30-quote-1.png\">\n        <img class=\"halfScale 30-quote\" style=\"top:691px; left:442px;\" src=\"/192/en/static/_content/30-quote-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.staggerFromTo(cOf(\"30-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop();\n        }\n      ",
    "searchText": "THE TECHNICIAN  and so on). I think analysis and conclusions should always bear in mind the question ‘Why do you win football matches?’ For me this is crucial when it comes to education of coaches and players. An important aspect here is to try to analyse the teams’ ways of playing in order to get coaches and players to understand how individual playing qualities can affect the way the team can play – both with and without the ball. The technical reports have evolved in a positive way and statistics are a good tool to see how football is changing. The possibility to illustrate analysis with video clips is, of course, a good step forward.”  ‘‘We tried to offer as much information as possible but my one wish would be to add even more visual material – to illustrate or animate the key tactical issues.”  30 – UEFA DIRECT • Q4 2020  the trends of a final tournament, especially concerning development of playing systems and priorities when it comes to the way of playing (possession play, zonal defending  ‘‘The technical reports have evolved in a positive way and statistics are a good tool to see how football is changing. The possibility to illustrate analysis with video clips is, of course, a good step forward.” UEFA  A didactic document Jorge Braz, current champion of Europe as head coach of Portugal’s futsal team, thinks along similar lines. “UEFA’s technical reports are a very important documents in the analysis and evaluation of the major competitions that are the main references to understand the state of the sport, and the evolutionary trend of the game. The reports are prepared by coaches with enormous experience, who know how to analyse the most relevant information. The documentation, illustrations and detailed analysis of what happens, are very important for young coaches – a didactic document revealing the dynamics of the best European teams. Keeping up with the ideologies of the coaches of the main national teams in Europe, analysing all the details, is mandatory for me and my own technical team.” Orlando Duarte, his predecessor on the Portugal bench, was one of the technical observers at Futsal EURO 2018. “It was a fantastic experience in terms of companionship, learning and knowledge. We tried to offer as much information as possible but my one wish would be to add even more visual material – to illustrate or animate the key tactical issues.” Lars Lagerbäck, head coach of Norway and quarter-finalist with Iceland at EURO 2016, thinks along similar lines. “It is always good and valuable to get a total view and see  Sportsfile  Orlando Duarte UEFA technical observer at Futsal EURO 2018  New tools His voice harmonises with UEFA’s song sheet. Historically, technical reports have tried to support observers’ views with statistical evidence even though, in the pioneering days, data were rudimentary. And plans to enhance technical reports have sometimes been frustrated by fundamentals, such as lack of quality footage from age-limit tournaments. “Even so, the evolution of the technical reports has been remarkable,” says Matikainen. “The associations that I have worked for use the reports for coach education, player development, club development and overall football development in various ways. The tools for observation, analysis and synthesis have become more advanced and that opens new angles for reports. They give us more material but the selection and editing processes are still the key elements.” At this point, it might be worth mentioning the unusually prolific use of quotation marks on these pages. But words about UEFA’s technical reports in a UEFA publication imply a risk of producing something akin  Lars Lagerbäck Norway’s national team coach"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE TECHNICIAN  UEFA  The technical observers at the UEFA Europa League final between Marseille and Atlético on 16 May 2018 in Lyon. Left to right: Milenko Ačimovič, Jerzy Engel, Mixu Paatelainen, Thomas Schaaf, Ghenadie Scurtul, Stefan Majewski, Frank K. Ludolph (UEFA head of football education services).  to a corporate media release with egotrip undertones. Hence the emphasis on other people’s comments – to the extent that UEFA conducted a survey among national associations at a coach education conference in Belfast, where the usefulness of UEFA’s technical reports received a vote of confidence via a rating of 82/100. This was an optimal result: a strongly positive response – with room for improvement. A voice from Sweden, for example, underlined “the importance of being able to convey the content in adapted form in our more advanced coach education courses. UEFA technical reports are, together with our own analyses, a vital and very appreciated part of our work among coach educators”. Or: “Thanks to UEFA! Modern football fundamentals are of key importance for developing the game in Georgia”. Or, from Croatia: “It is a great opportunity to keep up to date with the top UEFA football competitions”. Or, from Slovakia: “Technical reports are useful for coach education departments at all national associations and, for us, the digital format is especially useful.” A dedicated website That was in the autumn of 2017. Since then, a refurbishment scheme has gathered momentum. A library of technical reports is being built on the uefatechnicalreports.com platform. A specialised match analyst has  been drafted into the core team in Nyon. And, in addition to the broad-brushstroke analysis of playing systems, goalscoring patterns, set plays, goalkeeping, counterattacking, roles of full-backs, change-footed wingers and so on, reports have set out to illustrate match moments that the observers have pinpointed as interesting from a coaching perspective. At the same time, technology has moved on – and UEFA is exploiting it to upgrade data content and inject video links into reports to illustrate salient technical/tactical features. Without delving too deeply into IT aspects, technical observers are now starting to operate with tablets and mobile apps that allow them to immediately clip game situations that catch the eye as potentially significant. After the game, they have access to multiple camera angles – broadcast images, tactical and behind-goals footage, which can be injected into the technical report. The video clips can then be enhanced with state-of-the-art visualisation tools to overlay tactical graphics in an informative way which adds visual support to the points the observer wants to highlight. Back at the hotel – or even on the way there – observers can view the clips they have created, along with match data collected during the game, from numbers of passes, shots or crosses to more advanced data on distances covered, maximum speeds or average positional  locations on the field of play – decent support material for topics like the modus operandi of wing-backs, for example. During a high-intensity tournament like next year’s rearranged EURO 2020, with multiple games per day, this sort of rapid access to video and data will open up more time for tactical analysis, debate and, by comparing with previous competitions, looking at trends within the game as a whole and offering a more complete picture to coaches and coach educators via material which, it is hoped, can give added value to coach education courses. “I was first introduced to UEFA’s technical reports in the second half of the 1990s,” Matikainen recalls. “That was at the start of the internet era and access to international tendencies and influences was more difficult for a young coach learning his trade. The reports were very valuable and opened up a completely different level of coaching environment. Time has gone by and football demands have evolved. But using the experience and knowledge of top coaches to help national associations and individual coaches to identify requirements and come up with solutions in a highly challenging environment is still a key issue. The technical reports may now be published online; the quantity, quality and format of support material may have changed… but the insight and inspiration that they offer to coaches and coach educators remain exactly the same.” UEFA DIRECT • Q4 2020 – 31"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 32-title\" style=\"top:132px; left:217px;\" src=\"/192/en/static/_content/32-title-1.png\">\n        <img class=\"halfScale 32-sub\" style=\"top:284px; left:58px;\" src=\"/192/en/static/_content/32-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim.fromTo(cOf(\"32-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"32-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg32Anim.stop();\n        }\n      ",
    "searchText": "R. Jurković  RESEARCH GRANT PROGRAMME  ‘THE IMPORTANCE OF FOOTBALL FOR REFUGEES AND ASYLUM SEEKERS’  Dr Rahela Jurković was one of six recipients of a UEFA research grant for 2019/20, for a project titled ‘Football and refugees: cultural anthropology of the Balkan corridor’.  What led you into this area of research? The first trigger was the fact that for my doctoral dissertation – on the integration of refugees in Croatian society – I found out that football is one way to integrate people and that many refugees in Croatia play football. The second was that in 2015 and 2016 there were over 600,000 refugees and asylum seekers who passed through the ‘Balkan corridor’, so my idea was to research those countries. In cultural anthropology, which is my field, sport hasn’t been researched a lot, but I received support from the Croatian Football Federation, which suggested I research other countries too. How challenging was the process of going out in the field? The research period was eight months, from September 2019 to April this year, and I had to cover five countries. I had some assistance from interpreters – cultural mediators, let’s say – but the main work was done by myself. In Greece, I had only one or two contacts. I went first to Thessaloníki, and was walking around thinking, “How am I going to find migrants who play football?” But a key contact – a ‘gatekeeper’ as we call them in cultural anthropology – helped me, and I was able to reach more than I’d targeted. In total, I interviewed 71 refugees in these 32 – UEFA DIRECT • Q4 2020  five countries and 13 people working with refugees and football. Did those interviews confirm your expectations or throw up surprises? I was surprised. In Greece, where there are many more refugees and asylum seekers than in Croatia, I was surprised to see refugees who are playing football three times a day. I even heard of a few training with top-flight clubs. But my second surprise was that they had many difficulties in registering with local clubs. Registration is done by the national associations, but I heard that in Greece from 2015 to October last year, when we did the interviews, there were only four refugees registered with local teams. I spoke to many who wanted to be registered – they’re so happy to play football but are unhappy because they can’t show their talents on the field. Was it encouraging to encounter different organisations that help refugees? Of course, and one of my recommendations to UEFA and football in general was to support organisations trying to reach more people in this way. My report mentioned some of the people working across the five countries, such as Hope Refugee FC and Hestia FC in Athens. Hestia is the only women’s football club in the region. In Thessaloníki, there’s the Football for All initiative and the Arsis organisation. In Belgrade, I was with NGOs called Info Park and ADRA Community Centre. In Croatia, I met Mazen, a man who’s organising an informal group of people to help refugees through football. They all need support, though. A team like  Hope Refugee FC, run by the International Olympic Truce Centre in Athens, needs finances to work. If you want something to function for refugees, you need people  Hestia FC  W  ith the results of her research now presented to the UEFA Research Grant Jury, Dr Jurković talked to UEFA Direct about the importance of football for refugees and asylum seekers in Croatia, Bosnia and Herzegovina, Greece, North Macedonia and Serbia."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RESEARCH GRANT PROGRAMME  who are paid for their work. They’re working independently from the national associations, with money from different sources, but in the middle of each year they need to dedicate time to finding new funding. I hope my research shows that organisations behind football teams like Hope Refugee and Hestia are serious, with dedicated people. They’re an example, and I’d like to see bigger football bodies encourage them in their work. Did your research leave you feeling optimistic or pessimistic? I’m optimistic because I saw many talented people, people who want to show that, through football, they can do something. There are people with organisational capabilities who showed they can play football even though they had no equipment. Nobody organised them; they  organised themselves. In Athens, I saw a woman from Iran who started playing football at almost 40, and this was great for me – it breaks the prejudice that women should play only when they’re young. I heard stories of women who’d played football in Iran wearing the hijab, and they said it was much better to play without. There were also women from Afghanistan playing football in Hestia. Every one of them told me how football had helped them overcome depression and psychological problems. One woman cried after talking about how her life was before she joined this women’s football club. In the end we were all crying. How do you hope your research might influence people? I hope it will help raise awareness of the fact that refugees in Southeast Europe  play football. Some spend up to four years in camps, and they play football. But they need equipment, they need organised training sessions, and my suggestion to national associations and local football clubs is that they contact refugee centres and ask if they can help. Also, I hope I’ve offered examples of good practice – and that these organisations should have long-term support. “Finally, there is the question of registration in local clubs and how national regulations could be amended to allow asylum seekers to register, as FIFA regulations actually stipulate. One interviewee in Athens told me: “You’re allowed to work with asylum papers but cannot play football. How is this? How do you give us the right to work but not to play?”  Hestia FC, from Athens, promotes the integration of refugee and migrant women through football."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 34-title\" style=\"top:129px; left:58px;\" src=\"/192/en/static/_content/34-title-1.png\">\n        <img class=\"halfScale 34-sub\" style=\"top:249px; left:58px;\" src=\"/192/en/static/_content/34-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.fromTo(cOf(\"34-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"34-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg34Anim.stop();\n        }\n      ",
    "searchText": "UEFA GROW  UEFA GROW SUPPORTS ASSOCIATIONS WITH NEW FINANCE MANAGEMENT PILLAR At a time when member associations’ finances are facing more challenges and adjustments than ever, UEFA Grow has staged an Executive Finance Essentials course, as well as holding meetings for national association finance directors across Europe.  Getty Images  “  T  he plan is not that you have to be finance experts at the end of this seminar – it is more important that you know the basics and especially that you have an understanding of the key points to look out for in your national associations’ financial statements and planning in order to ask the right questions,” said UEFA’s finance director, Josef Koller, at the beginning of the first webinar of UEFA Grow’s three-part Executive Financial Essentials course in September.  The central aim of the course was to provide national associations’ board members, general secretaries and senior leaders with a better understanding of financial figures and reporting – of particular importance today given the need for informed strategic decision-making in the face of the COVID-19 pandemic. Staged across three interactive lunchtime sessions, the course formed a key part of UEFA Grow’s new finance management pillar alongside a series of regional finance  director meetings which have taken place across Europe, the first of them for the Nordic associations in late May. Good governance and financial sustainability are core goals of the Grow strategy and with these meetings UEFA is seeking to understand the particular challenges faced by national associations at this unprecedented time, as well as to highlight best practices. Fundamentals of finance UEFA’s Grow team put in place the Executive  The Portuguese Football Federation – whose national team are the reigning European champions and UEFA Nations League titleholders – took part in the first Executive Finance Essentials course held as part of the UEFA Grow programme."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 35-quote\" style=\"top:143px; left:454px;\" src=\"/192/en/static/_content/35-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax();\n          pg35Anim.fromTo(cOf(\"35-quote\"), 0.6, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg35Anim.stop();\n        }\n      ",
    "searchText": "UEFA GROW  ”Finance is a key area in any kind of business organisation, and it is important for UEFA to ensure the well-being of each national association.”  UEFA  Josef Koller UEFA finance director  Finance Essentials course with the guidance and support of Francesc Solanellas, a professor of sports management from the National Institute of Physical Education and Sport of Catalonia (INEFC). The UEFA Academy, the finance division and the finance directors of UEFA’s member associations also collaborated in a shared effort to address the not-uncommon scenario of national association staff leaving finance to financial experts because of its perceived complexity. The new course – offering case studies from finance directors at national associations around Europe – has given participants the chance to gain a grounding in the fundamentals of finance, particularly those executives, board members and senior management previously lacking experience in this field. All national associations were invited to send up to four elected or appointed members of their leadership team (executive committee members, president, general secretary or deputy general secretary) and around 150 people joined Josef Koller for the first two-hour webinar on 9 September, which offered an ‘Introduction to finance, annual financial reports and auditing’. That introduction came from Solanellas, with case studies following from Portugal and the Czech Republic. For participants, there was a Q&A with each speaker involved, and the feedback was highly positive, with 96% of those taking part declaring themselves “very satisfied”.  The second webinar, a week later, addressed the topics of ‘Financing your strategy, budgeting and forecasting’, while the third and final session, on 30 September, considered ‘Financial risk assessment and contemporary financial challenges for national associations’. The fact the webinars were recorded means they are available to national associations’ executive committees and staff as well as affiliated regional associations, to share best practices wider. ‘Facts behind the figures’ Reflecting on the significance of the seminars, Josef Koller said: “Finance is a key area in any kind of business organisation, so I am pleased to see so many members of national associations interested in building a solid grounding in the fundamentals of finance, which will support them in building up their skills to find the facts behind the figures and make more informed financial decisions.” In tandem with the Executive Finance Essentials course, UEFA Grow also held a number of regional finance director meetings during the past quarter. These represent an opportunity to get to know other finance directors and to become more involved in UEFA’s strategic planning. For UEFA’s Grow team, it is a chance to understand better the current financial situation in each country and the particular challenges that the pandemic has brought in different regions.  Nordic meeting first Denmark, the Faroe Islands, Finland, Iceland, Norway and Sweden were the countries involved in the first meeting for the Nordic finance directors on 21 May. The meeting agenda included assessing the financial profile of each association involved and discussing the effects of COVID-19 and the actions put in place in response. A month later, on 23 June, it was the turn of the Anglophone finance directors – England, Northern Ireland, the Republic of Ireland, Scotland and Wales – with the western finance directors’ meeting following on 14 August for Belgium, France, Germany, the Netherlands, Portugal and Spain. ‘Exchange and share knowledge’ Speaking after this last-mentioned meeting, Ron Francis, finance director of the Royal Netherlands Football Association, said: “It is the very first time that the finance directors of the western region have met together. This great initiative from UEFA Grow to connect the different finance directors has allowed us to exchange and share our knowledge for the benefit of European football.” The latest meeting, on 18 September, covered the central region, with directors from Austria, the Czech Republic, Hungary, Italy, Poland, Slovakia and Switzerland all attending. Next up are meetings for the eastern and southern regions, with the Grow team working to ensure this opportunity is available to finance directors across the length and breadth of the continent. UEFA DIRECT • Q4 2020 – 35"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 36-title\" style=\"top:84px; left:59px;\" src=\"/192/en/static/_content/36-title-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n          pg36Anim.fromTo(cOf(\"36-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        }\n        function onPageLeave() {\n          pg36Anim.stop();\n        }\n      ",
    "searchText": "COMPETITIONS  UEFA WOMEN’S, FUTSAL AND YOUTH COMPETITIONS POSTPONED TO NOVEMBER  I  n order to alleviate the additional operational and financial burden on national associations – caused by hygiene conditions impacting travel and accommodation, as well as testing to safeguard the health of athletes and minimise any potential risk of spreading the COVID-19 infection – the UEFA Executive Committee took the following decisions regarding UEFA women's, futsal and youth competitions on 13 August and 15 September:  2019/20 competitions  European Women’s Under-17 Championship • Cancellation of the elite round and final tournament • If the U-17 Women’s World Cup is confirmed, the three European teams with the highest coefficient rankings will qualify (England, Germany and Spain, in alphabetical order)  UEFA  European Men’s Under-19 Championship • Elite round postponed to November 2020 (from October 2020) and final eight tournament to be played in Northern Ireland in March 2021 • Final eight tournament format amended to now consist of a straight knockout phase with quarter-finals, semi-finals and the final (and play-off matches to qualify a fifth European team for the 2021 U-20 World Cup).  36 – UEFA DIRECT • Q4 2020  2020/21 competitions  • • • •  European Women’s Under-17 Championship Qualifying round to be played by end February 2021 (12 mini-tournaments) Elite round abolished and replaced by play-offs Play-offs (14 teams) to be played by end March 2021 Final tournament as scheduled (Faroe Islands, May 2021)  European Men’s Under-17 Championship • Qualifying round to be played by end March 2021 (13 mini-tournaments) • Elite round abolished • 13 group winners and two seeded teams qualify for final tournament, to be played as scheduled (Cyprus, May 2021)  • • • •  European Women’s Under-19 Championship Qualifying round to be played in February 2021 (12 mini-tournaments) Elite round abolished and replaced by play-offs Play-offs (14 teams) to be played in April 2021 Final tournament as scheduled (Belarus, July 2021)  • • • •  European Men’s Under-19 Championship Qualifying round to be played in March 2021 (13 mini-tournaments) Elite round abolished and replaced by play-offs Play-offs (14 teams) to be played by end May 2021 Final tournament as scheduled (Romania, July 2021)  UEFA Women’s Champions League • Preliminary round mini-tournaments replaced by two single-leg knockout rounds with 40 teams in the first qualifying round on 3/4 November and 20 teams in the second qualifying round on 18/19 November 2020 • Round of 32 postponed to 8/9 and 15/16 December 2020 • Remainder of the competition to be played as originally scheduled: • Round of 16 and quarter-finals in March 2021 • Semi-finals in April 2021 • Final in May 2021 UEFA Futsal Champions League • Preliminary, main and elite rounds (all originally planned with mini-tournaments) replaced by single-leg knockout rounds – preliminary round in November 2020, main round (round of 32) in January 2021 and elite round (round of 16) in February 2021 • Final eight (instead of final four) in April or May 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 37-title\" style=\"top:129px; left:158px;\" src=\"/192/en/static/_content/37-title-1.png\">\n        <img class=\"halfScale 37-sub\" style=\"top:246px; left:71px;\" src=\"/192/en/static/_content/37-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax();\n          pg37Anim.fromTo(cOf(\"37-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"37-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg37Anim.stop();\n        }\n      ",
    "searchText": "GIBRALTAR  NEW LOGO UNVEILED TO COINCIDE WITH MILESTONE ANNIVERSARY This year marks the Gibraltar FA’s 125th anniversary. Unfortunately, owing to the COVID-19 pandemic and the direct effect it has had on our community, the association has been unable to stage its planned programme of events to mark this historic occasion. BY STEVEN GONZALEZ  team head coach Julio Ribas asked his players and staff to turn to face the rock as they sang the national anthem. This has now become a key part of the national teams’ pre-match ritual, with the supporters following suit. Using a modern design on the angle of the Rock of Gibraltar, as seen from Victoria Stadium, the association’s new logo features two vertically pointing chevrons or arrowheads. The two chevrons symbolise the old and the new. Into a new decade, the Gibraltar FA faces new challenges, challenges that it is duty-bound to undertake as the standard bearer for Gibraltarian football. In doing so, the association must not forget all the work that has been done in the past 125 years, during which football has played an enormous part in the growth and development of our wonderful community. Ivan Robba, Gibraltar FA general secretary, said: “The new logo is a key part  of launching the Gibraltar FA into a new, modern and professional sporting association. We were very clear that we wanted a unique and relevant new identity that is in keeping with global footballing trends but simultaneously reflects the association’s core values and principles. The iconic image of the Rock of Gibraltar watching over Victoria Stadium has, for decades, inspired generations of Gibraltarian footballers, and the further this concept was developed, the clearer it became that this needed to be central to our new identity. The two upward pointing chevrons on the logo represent the Gibraltar FA moving into a new dawn without forgetting the sterling work that has been done by everyone involved in the association since it was founded in 1895. From now on, wherever a Gibraltar national football team take the field of play, they will be wearing the Rock of Gibraltar on their chests.”  Getty Images  N  evertheless, it was important that this landmark year be recognised with one significant change, and that it be introduced in time for the start of Gibraltar’s UEFA Nations League campaign at Victoria Stadium. Working closely with the UEFA Grow programme, which aims to help the UEFA member associations develop into ‘Football Federations of the Future’, the Gibraltar FA embarked on an in-depth project to redesign its logo and visual identity, with UEFA’s industry experts’ research into the current logo laying the foundation for both the design work and its overall look and feel. In scoping and researching the new logo, the association was clear that its new visual focal point should be intertwined with iconic imagery of our beloved nation, and reflect a modern, forward-thinking visual and corporate identity to drive the Gibraltar FA into the new decade and the next generation. Ever since football has been played at Victoria Stadium, one landmark vision of Gibraltar has always stood out: the view of the Rock of Gibraltar from the centre circle. The rock has watched over generations of footballers who have filled Gibraltar with pride, from the old Nortex, gravel and sand-based pitches in the 1950s and 60s, through the 1970s and 80s, and then into the 1990s and the first artificial surfaces, with various visiting teams and the unforgettable Sunshine Games [Island Games], right through into the new millennium and, ultimately, the modern age of UEFA and FIFA membership. In the first competitive international as UEFA and FIFA members at Victoria Stadium in 2018, Gibraltar men’s national  UEFA DIRECT • Q4 2020 – 37"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 38-title\" style=\"top:366px; left:58px;\" src=\"/192/en/static/_content/38-title-1.png\">\n        <img class=\"halfScale 38-sub\" style=\"top:443px; left:58px;\" src=\"/192/en/static/_content/38-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.fromTo(cOf(\"38-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .staggerFromTo(cOf(\"38-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, \"-=0.3\")\n        }\n        function onPageLeave() {\n          pg38Anim.stop();\n        }\n      ",
    "searchText": "LITHUANIA UEFA YOUTH LEAGUE  A NEW VISUAL IDENTITY Following a rebranding process, the Lithuanian Football Federation (LFF) and the national team now each have their own distinct logo. BY AGNĖ RUDYTĖ  T  he logos were created by the Frame agency alongside UEFA Grow programme experts. The role of the Lithuanian Football Federation is to develop and promote football. To do this effectively, the game needs to be protected, making a shield an ideal icon. In addition, it has a unique Lithuanian shape, which gives us an icon that is distinct to the LFF. To ensure the logo is easily recognisable as the emblem of a football association, it also incorporates a football and the initials of the federation, which sit confidently within the shield, while the full name sits on top to depict the federation’s role as the top governing body of football in Lithuania. As it is a national federation, the Lithuanian national flag is also featured, which will help to give the logo a Lithuanian identifier when used internationally. “Over the last few years, there have been lots of positive changes inside the federation, as our aim is to become a modern organisation. The current LFF logo dates back to 2009, so it was obvious that 38 – UEFA DIRECT • Q4 2020  the time had come for a change, and we had to update the logo. Working shoulder to shoulder with the UEFA Grow programme, we started to develop new plans to improve the federation, and one of them was to update our brand identity,” explained Edgaras Stankevičius, the LFF general secretary. The national team logo is a modern reinterpretation of Lithuania‘s historic national symbol. To achieve a simple and uncluttered image, the designers cropped out the hind legs of the horse and brought the focus closer to the triumphant pose of the knight. The resulting pictogram takes on a shield-like footprint that echoes the shape of the knight’s shield. The logo is built on an isometric grid that ensures uniformity between all the angled lines and hard-cut edges, which is prevalent in Lithuanian design. “I think the new logo looks great – it is more modern. It is a symbol of courage and determination, and these features are incredibly important in football,” said Lithuanian international Džiugas Bartkus.  This summer, the Lithuanian Football Federation started a new pilot project aimed at getting more women to play and watch football by introducing them to the game with the help of open training sessions. On 13 June, the LFF stadium in Vilnius was taken over by women when national team captain Milda Liužinaitė and player/ grassroots project manager Greta Guižauskaitė led the first training session organised by the federation. Since then, a further two sessions have taken place. The second session took place before the LFF Cup final. Luckily for Lithuania, thanks to welltimed measures to manage the COVID-19 pandemic, up to 1,000 spectators could attend sports events. This meant that all the participants in the second session were able to stay and watch the cup final afterwards. The third session was another big milestone. It was organised before the first match in the newly established women’s regional league. This session also helped to attract mothers who have children playing football. They said it was an amazing opportunity to try out the sport their children love so much and help connect with them more. Participants said they really enjoyed the sessions and would be willing to return to the stadium for future events of this kind. They said the training sessions were interesting and helped them to get to know football.  LFF  LFF  Pilot project to attract more women into football"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 39-title\" style=\"top:152px; left:71px;\" src=\"/192/en/static/_content/39-title-1.png\">\n        <img class=\"halfScale 39-sub\" style=\"top:188px; left:71px;\" src=\"/192/en/static/_content/39-sub-1.png\">\n        <img class=\"halfScale 39-title\" style=\"top:412px; left:71px;\" src=\"/192/en/static/_content/39-title-2.png\">\n        <img class=\"halfScale 39-sub\" style=\"top:471px; left:71px;\" src=\"/192/en/static/_content/39-sub-2.png\">\n        <img class=\"halfScale 39-title\" style=\"top:612px; left:71px;\" src=\"/192/en/static/_content/39-title-3.png\">\n        <img class=\"halfScale 39-sub\" style=\"top:648px; left:71px;\" src=\"/192/en/static/_content/39-sub-3.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim.staggerFromTo(cOf(\"39-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"39-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg39Anim.stop();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  ALBANIA  www.fshf.org  REBUILDING AFTER THE EARTHQUAKE ANDI VERÇANI  The Albanian Football Association has started rebuilding one of the houses destroyed by the devastating earthquake of 26 November 2019. Present as work began were Albanian FA president Armand Duka, men’s national team coach Edoardo Reja, men’s national team players Elseid Hysaj and Etrit Berisha, and women’s international Megi Doçi. The houses are being rebuilt by the association thanks to contributions from the association, national team staff, players and partner associations. Under the motto, ‘We are a team; we  rebuild together’, Armand Duka, Edoardo Reja and the players took part in the symbolic ceremony to lay the first brick of the new house. The Albanian FA president thanked everyone who had contributed to this project: “The pandemic interrupted our project for some time. Following the tragic earthquake last November, all of us within the association – all the national team players, the coach and partner associations – took the initiative and opened an account to provide modest  assistance to rebuild some of the houses. This is the first house we are helping to rebuild, and after this we will build three more.” Coach Reja said: “The moment we learned what had happened with the earthquake, we asked the president and the association if we could participate in the reconstruction work. It was a pleasure to be part of this ceremony, to lay the first brick, and I hope that people will be able to return to their normal lives after all the difficulties they have gone through.”  AZERBAIJAN  www.affa.az AFFA  A NEW HEAD COACH FOR THE MEN’S NATIONAL TEAM  Gianni de Biasi  FIRUZ ABDULLA  The Azerbaijan national team start the 2020/21 UEFA Nations League under a new head coach. The negotiations between the Azerbaijan Football Federations Association and Gianni de Biasi ended positively and a  contract was signed on 30 July, covering the 2020/21 UEFA Nations League and the qualifying competition for the 2022 World Cup. After his appointment was announced, the Italian coach said: “I am pleased to be the head coach of the  BELARUS  Azerbaijan national team. I am ready use all my knowledge and skills to raise this team as high as possible. I want Azerbaijan to go higher in the rankings and to succeed.” www.abff.by  NEW NATIONAL TEAM KITS PRESENTED IN MINSK The Belarus Football Federation has presented the new kit of the national team, created through UEFA’s kit assistance scheme in partnership with manufacturer Macron. The new home shirt is a white crewneck with knit trims. The neck tape features a traditional Belarusian pattern, while the backneck is personalised with the hashtag #БЕЛЫЯКРЫЛЫ (white wings). Мы - Беларысы (We are Belarusians) is embroidered in white on the back collar. The distinguishing element of the shirt is the central vertical band featuring the traditional  ABFF  ALEKSANDR ALEINIK  Belarusian pattern in embossed graphic tone on tone. The very colourful emblem of Belarus occupies the left chest. The shorts are white with white drawstring and red  tips, and the socks are white with a red upper edge. The new away shirt is a polo with similar stylistic elements. Red is the dominant colour. Like the new home shirt, the backneck and the back collar are both personalised with the hashtag and the name of the country in Cyrillic alphabet. Red shorts with white drawstring and red socks with a white upper band complete the kit. For the goalkeepers, three kits have been created: neon green with black details, charcoal grey with neon green details and light blue with black details. UEFA DIRECT • Q4 2020 – 39"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 40-title\" style=\"top:152px; left:57px;\" src=\"/192/en/static/_content/40-title-1.png\">\n        <img class=\"halfScale 40-sub\" style=\"top:211px; left:57px;\" src=\"/192/en/static/_content/40-sub-1.png\">\n        <img class=\"halfScale 40-title\" style=\"top:505px; left:57px;\" src=\"/192/en/static/_content/40-title-2.png\">\n        <img class=\"halfScale 40-sub\" style=\"top:564px; left:57px;\" src=\"/192/en/static/_content/40-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.staggerFromTo(cOf(\"40-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"40-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg40Anim.stop();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  BULGARIA  www.bfunion.bg  GRASSROOTS PROGRAMME BOOSTED WITH FOUR NEW TRAINING CENTRES HRISTO ZAPRYANOV  the financial support of UEFA. The first three facilities are in the Nadezhda district  of the capital, Sofia, and in the towns of Pazardzhik and Silistra.  BFU  The Bulgarian Football Union (BFU) continues to support grassroots football in the country even in these most uncertain times. The BFU’s general secretary, Borislav Popov, and the mayor of Sandanski, Atanas Stoyanov, officially opened a new state-of-the-art facility in the country’s south-western region. The training centre incorporates three artificial pitches, which will host matches in Bulgaria’s minifootball league. “This is the proper way to develop the future stars of Bulgarian football. I am certain that the new Berbatovs and Stoichkovs will make their first steps on pitches like these,” Mayor Stoyanov said. The Sandanski training centre is the fourth to be completed by the BFU with CROATIA  www.hns-cff.hr  CROATIAN FOOTBALL GOES GLOBAL WITH NEW TV RIGHTS PARTNER NIKA BAHTIJAREVIĆ  40 – UEFA DIRECT • Q4 2020  friendlies of the men’s senior national team. The new contract will result in a multiple-fold increase in the funds that clubs receive from TV rights and will be of major benefit to the entire Croatian football family. “Our partnership with Endorphin reflects the growing international appeal of our competitions and is the start of a new era for Croatian football – which has experienced a real boom in recent years, both in terms of our excellent national teams and in terms of the performance of our clubs. The hard work within our football clubs helped us raise the profile of our competitions and land an impressive contract like this one. In turn, our partnership with Endorphin will be hugely beneficial for clubs and will help them grow even further. We look forward to working with Endorphin in promoting  Croatian football on a global scale and in bringing our competitions and our national teams to a wider audience,” said the HNS president, Davor Šuker.  HNS  Though the global pandemic of the novel coronavirus has had major financial implications for football clubs worldwide, Croatia’s professional clubs have been able to take solace in an exciting announcement made by the Croatian Football Federation (HNS) in early August. After a public tender for broadcasting rights to matches overseen by the federation, the HNS happily confirmed that it had signed its biggest TV rights contract to date with new media partner Endorphin Magine Ltd. Beginning with the 2022/23 season, Endorphin will take over the production and distribution of all matches in the HNS’s portfolio – which includes men’s and women’s club competitions, all available futsal national team, youth national team and women’s national team matches, and non-centralised"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 41-title\" style=\"top:152px; left:71px;\" src=\"/192/en/static/_content/41-title-1.png\">\n        <img class=\"halfScale 41-sub\" style=\"top:188px; left:71px;\" src=\"/192/en/static/_content/41-sub-1.png\">\n        <img class=\"halfScale 41-title\" style=\"top:506px; left:71px;\" src=\"/192/en/static/_content/41-title-2.png\">\n        <img class=\"halfScale 41-sub\" style=\"top:565px; left:71px;\" src=\"/192/en/static/_content/41-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:438px;left:589px;width:32px;height:12px;\">\n          <a href=\"https://landsholdslejren.buzzsprout.com/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:449px;left:458px;width:138px;height:12px;\">\n          <a href=\"https://landsholdslejren.buzzsprout.com/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:815px;left:519px;width:90px;height:12px;\">\n          <a href=\"//TheFA.com/HeadsUp\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:827px;left:457px;width:137px;height:12px;\">\n          <a href=\"//headstogether.org.uk/heads-up\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax();\n          pg41Anim.staggerFromTo(cOf(\"41-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"41-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg41Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  DENMARK  www.dbu.dk  PODCAST FROM THE NATIONAL TEAMS’ CAMPS MICHELLE THYGESEN  popular podcast on iTunes Denmark in the sports category. A subsequent episode took the fans on a journey with Mathias ‘Zanka’ Jørgensen and Jonas Lössl from being best friends as children to representing their country on the field together. Also coming up are podcast episodes with the head coach of the women’s national team, Lars Søndergaard, from the women’s camp, and much more. You can find out more about the podcast and how to listen here: https:// landsholdslejren.buzzsprout.com/. fodboldbilleder.dk  Players, coaches and staff of the Danish national teams are joining host and fan coordinator Anders Hagen in a newly launched podcast. The idea is to provide fans with exclusive insight into the team camps at a time when public access to the players is limited. The podcast launched on the day of the call-up for the men’s senior national team on 24 August – the first squad for Kasper Hjulmand as head coach of the team following the departure of Åge Hareide. The podcast episode allowed the audience to get up close and personal with the new man in charge, and revealed – in detail – his thinking behind choosing the players who would play Denmark’s important UEFA Nations League matches against star-studded Belgium and England on 5 and 8 September.  The first episode was launched on several channels and received a warm reception from fans, with more than 2,500 subscribers in the first 24 hours. Since then, more than 10,000 listeners have tuned in and doubled the number of streams, making it the second most  ENGLAND  www.thefa.com  FA CUP FINAL FILLS WEMBLEY WITH THE ‘SOUND OF SUPPORT’ FOR MENTAL HEALTH In August, the 2019/20 FA Cup concluded with a final dedicated to the nation’s mental health. Thanks to the support of lead commercial partner Emirates, the showpiece event was titled ‘The Heads Up FA Cup Final’. The final was a culmination of the English FA and Heads Together’s season-long Heads Up campaign. Spearheaded by HRH The Duke of Cambridge, Heads Up harnessed the influence and popularity of football to encourage more people to feel comfortable talking about, and taking action to improve, their mental health. In recognition of the unprecedented circumstances surrounding the fixture – the first FA Cup final to be held behind closed doors – the theme was the #SoundOfSupport. While Wembley Stadium was silent, the conversation  TheFA  DAVID GERTY  around mental health was louder than ever, and fans were urged to show the  ‘sound of support’ – and to make sure it was heard by those who need it. Ahead of kick-off, there was a powerful 60-second #SoundOfSupport moment dedicated to Heads Up. Unique artificial crowd noise was played in the stadium, created from a soundscape of real mental health conversations with fans and players. The crowd noise was introduced to the players and fans by a rallying spoken-word piece from poet and mental health champion Hussain Manawer. Heads Up branding was prominent around the stadium, including the trophy’s ribbons, and both clubs and match officials showed their support with the campaign’s logo on their match kit. For more information on the Heads Up campaign visit TheFA.com/HeadsUp and headstogether.org.uk/heads-up. UEFA DIRECT • Q4 2020 – 41"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 42-title\" style=\"top:152px; left:57px;\" src=\"/192/en/static/_content/42-title-1.png\">\n        <img class=\"halfScale 42-sub\" style=\"top:188px; left:57px;\" src=\"/192/en/static/_content/42-sub-1.png\">\n        <img class=\"halfScale 42-title\" style=\"top:635px; left:57px;\" src=\"/192/en/static/_content/42-title-2.png\">\n        <img class=\"halfScale 42-sub\" style=\"top:671px; left:57px;\" src=\"/192/en/static/_content/42-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim.staggerFromTo(cOf(\"42-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"42-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg42Anim.stop();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  ESTONIA  www.jalgpall.ee  EDUCATION FOR PROSPECTIVE REFEREES The Estonian Football Association runs a popular basic training course for prospective referees. This year, around 100 would-be referees signed up for the course. The only requirement is that participants have to be at least 15 years old. The course takes place simultaneously in four locations all over Estonia. The first part of this year’s course took place at the end of August, with the second part scheduled for mid-October. On completion of the first part of the basic training, the budding referees can referee matches at certain youth levels and can be appointed by the association to officiate as assistant referees at other levels. The Estonian FA has put more emphasis on the training and well-being of referees in recent years. This summer, the association created regional head of refereeing positions. Their duty is to organise and run regional workshops for referees and help them as needed. Opening the way for everyone to become a referee is essential in producing world-class referees. Recently, UEFA category 1 referee Kristo Tohver took charge of two Saudi Pro League matches, assisted by Silver Kõiv and Sten Klaasen.  Brit Maria Tael/Estonian FA  CARLOS KUIV  It was the Estonian officials’ first experience of using VAR. Then, at the end of August, FIFA assistant referee Karolin  FAROE ISLANDS  Kaivoja was appointed for the UEFA Women’s Champions League semi-final between Paris Saint-Germain and Lyon. www.football.fo  PUTTING EFFORT INTO WOMEN’S FOOTBALL TERJI NIELSEN  42 – UEFA DIRECT • Q4 2020  Maria Ziskason Nesá  FSF  The Faroese FA has been planning for a long time to make a greater effort in developing women’s football in the Faroe Islands. To assist it in that direction, the association has created a new position, that of head of women’s football, and appointed Maria Ziskason Nesá to take up that role. “Maria’s job will be to take charge of developing women’s football, and we are also working on developing a new strategy for women’s football in the  islands, which she will also be in charge of,” said Pætur Smith Clementsen, technical director of the Faroese FA. In May next year, the Faroe Islands are due to host the European Women’s Under-17 Championship final tournament. “We want our new strategy to be ready for the finals, so that we can present it during the tournament. But we also want our head of women’s football to make women’s football more visible in our country,” Clementsen added."
  }], [(_ref2 = {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 43-title\" style=\"top:152px; left:71px;\" src=\"/192/en/static/_content/43-title-1.png\">\n        <img class=\"halfScale 43-sub\" style=\"top:211px; left:71px;\" src=\"/192/en/static/_content/43-sub-1.png\">\n        <img class=\"halfScale 43-title\" style=\"top:494px; left:71px;\" src=\"/192/en/static/_content/43-title-2.png\">\n        <img class=\"halfScale 43-sub\" style=\"top:530px; left:71px;\" src=\"/192/en/static/_content/43-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax();\n          pg43Anim.staggerFromTo(cOf(\"43-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"43-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg43Anim.stop();\n        }\n      "
  }, defineProperty_default()(_ref2, "script", "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax();\n          pg43Anim.staggerFromTo(cOf(\"43-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"43-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg43Anim.stop();\n        }\n      "), defineProperty_default()(_ref2, "searchText", "MEMBER ASSOCIATIONS  GEORGIA  www.gff.ge  LONG-AWAITED FOOTBALL CENTRE INAUGURATED IN POTI The grand opening of the new Georgian Football Federation (GFF) football centre in Poti took place on 2 September with a friendly match between the local amateur club Chabonama and a GFF team that included former players from different eras. Before the match, the GFF president, Levan Kobiashvili, addressed young people from local football schools and other members of the public who attended the opening ceremony. “I am immensely proud of this project. I visited this location several years ago and saw the conditions in which children had to play football. I am happy that the city of Poti now has something that it was lacking for such a long time. The new  GFF  TATA BURDULI  football centre represents a major step forward for the development of youth football in this region. I must also emphasise that the local amateur and women’s clubs will be able to use these facilities. I am certain that the new  HUNGARY  modern infrastructure will ensure that more people will become involved in the game. Our precise objective is to develop football infrastructure and help popularise football and healthy lifestyle all over Georgia,” the GFF president said. The new facilities include two full-size pitches with floodlights, changing rooms, a stand and an administrative building. Construction of the football centre began in July 2019 and was co-funded by the GFF and the UEFA HatTrick and FIFA Forward programmes. Local football schools, as well as amateur and women’s clubs, will be able to use the facilities free of charge. Upkeep of the centre will be carried out by the GFF. www.en.mlsz.hu  LEAGUE COMPLETED ON TIME MÁRTON DINNYÉS  Ever since the outbreak of the coronavirus pandemic in Hungary, the Hungarian Football Federation (MLSZ) has continually reacted to government decisions and acted to protect participants in football matches. Fixtures that would decide prospective participants in UEFA competitions the following season were rescheduled for May and June, and were completed on time. In response to the government’s decision of 11 March, the MLSZ ordered football matches in Hungary to be played behind closed doors. Three days later, the federation announced that it would suspend youth-level championships from 16 March. When this happened, Hungarian football came to a standstill; no matches were played in Hungary from 16 March and training courses already organised by the MLSZ were also suspended. Against this background, the MLSZ held  its leadership elections digitally on 21 April, the first of UEFA’s member nations to hold such an event entirely online, and Sándor Csányi was unanimously elected president for another five years. Then, in May, footballers were able to return to action, initially behind closed doors. The OTP Bank Liga, Hungarian Cup and Women’s Simple League resumed, albeit under strict conditions. Hungary was one of the first countries to resume football. The first matches to be played were the Hungarian Cup semi-finals (on 23 May). On the weekend of 29 May, the men’s OTP Bank Liga resumed from the 26th round in front of a limited number of spectators. The women’s league also continued with the play-off final to decide which team would represent Hungary in the UEFA Women’s Champions League. The futsal and outdoor amateur and youth leagues did not resume after the March shutdown. During this period, sports zones had to be set up in stadiums,  which could only be accessed by people with a negative test result. From 29 May, matches could be played in front of fans, but still under strict regulations and with spectators socially distancing by 1.5 metres. The Hungarian Cup final between Budapest Honvéd and Mezőkövesd FC at the new Puskás Aréna on 3 June was held under these conditions. Limits on the number of spectators were lifted on 18 June. At the same time, in order to protect the health of players and staff, the testing process remained a priority, and decision-making in relation to this became the clubs’ responsibility. The 2019/20 OTP Bank Liga season was completed by 27 June, in accordance with the revised schedule. In total, 543 players were tested and altogether 5,157 PCR tests were made during this period. There were no active positive cases and six serological (past) cases. UEFA DIRECT • Q4 2020 – 43"), _ref2)], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 44-title\" style=\"top:152px; left:57px;\" src=\"/192/en/static/_content/44-title-1.png\">\n        <img class=\"halfScale 44-sub\" style=\"top:188px; left:57px;\" src=\"/192/en/static/_content/44-sub-1.png\">\n        <img class=\"halfScale 44-title\" style=\"top:575px; left:57px;\" src=\"/192/en/static/_content/44-title-2.png\">\n        <img class=\"halfScale 44-sub\" style=\"top:611px; left:57px;\" src=\"/192/en/static/_content/44-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:148px;left:53px;width:562px;height:27px;\">\n        <a href=\"https://www.figc.it/it/federazione/federazione-trasparente/reportcalcio/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg44Anim = new TimelineMax();\n          pg44Anim.staggerFromTo(cOf(\"44-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"44-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg44Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  ITALY  www.figc.it  TENTH EDITION OF REPORTCALCIO PUBLISHED DIEGO ANTENOZIO  4.6 million players, over 570,000 official matches, 1.4 million registered members, and a socioeconomic impact of nearly €3.1 billion – these are some of the figures to emerge from the tenth edition of ReportCalcio, the annual report on Italian football produced by the Italian Football Association’s (FIGC) research centre in collaboration with AREL (the research and legislation agency) and PwC. With 12,127 clubs and 64,827 teams, football confirms its position as the number one sport in Italy, generating €3.8 billion in revenues from professional football and making a tax and social contribution amounting to almost €1.3 billion. The report offers a comprehensive analysis divided into different chapters, including a census of Italian football, national teams (analysed from sporting, media and commercial perspectives), youth and amateur football, economic profile of professional football, and international benchmarking. This tenth edition also includes a new chapter that looks at the fan base profile.  Commenting on the report, the FIGC president, Gabriele Gravina, said: “The ten-year journey of transparency undertaken by the FIGC has been stepped up and provides an unfiltered view of the positive and critical aspects of the world of football. While the association plans to continue to invest in the growth of our sport, with its unparalleled socio-economic payback, we would like to focus our strategy and development on the scope for improvement.” With regard to the economic and tax profile of professional football, overall revenues in 2018/19 grew by 8.5% thanks to higher commercial (+19.7%) and media rights revenues (+11.8%), while capital gains decreased by 3.1%, a sign of clubs better managing their core business. The total tax and social security contribution amounted to €1.3 billion in 2017 (+7.4% compared with 2016 and +47% compared with 2006). This resulted in an increase in resources benefitting the entire Italian sports sector (+€60m redistributed in 2019 and  +€95m in 2020). Each euro ‘invested’ by the government in football brings a tax and social security return of €16.1 for the country. Professional football alone accounts for 71.5% of total tax contributions from the Italian sports industry. There are still critical issues on the infrastructure side to be resolved, despite an encouraging reversal of the trend on work carried on existing stadiums, largely due to Italy hosting the European Under-21 Championship final tournament last summer, which generated investment in promotional and renovation activities of more than €30 million. Italy accounted for only about 1% of total investments in new stadiums in Europe between 2009 and 2019, with stadiums in Italy an average of 63 years old. The COVID-19 pandemic has further accelerated the transformation of the different entertainment sectors, making it necessary to explore more effective fan engagement models and consolidate the digital revolution.  LATVIA  www.lff.lv  NEW PRESIDENT AND BOARD ELECTED TOMS ĀRMANIS  LFF  The members of the Latvian Football Federation (LFF) have elected a new president and board to lead the development of Latvian football for the next four years. Vadims Ļašenko was elected as the new  44 – UEFA DIRECT • Q4 2020  president of the LFF, winning 96 votes from the 129 members present at the federation’s annual congress. Vadims Ļašenko is no stranger to Latvian football. He played for the national futsal team 42 times, wearing the captain’s armband for a long spell. At club level, he won the Latvian futsal championship seven times. Early in his career, Ļašenko was an active referee, later becoming a UEFA delegate. He served as president of the Latvian futsal association since its inception in 2014, stepping down after being elected as president of the LFF. “I know it is important to the members of LFF to have someone from their own ranks as the leader of Latvian  football. I know their needs, ideas and difficulties very well and, therefore, together with my team, I can unite everyone into one forward-thinking mechanism that can give Latvian football a new and much needed boost,” Ļašenko said after his election. The new LFF board consists of eight members, including two women. The board confirmed Edgars Pukinsks as the LFF general secretary. Prior to the congress, Jurijs Andrejevs was appointed as the new sporting director of the LFF, replacing Dainis Kazakevičs, who was appointed as the new head coach of the Latvian men’s national team."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 45-title\" style=\"top:152px; left:71px;\" src=\"/192/en/static/_content/45-title-1.png\">\n        <img class=\"halfScale 45-sub\" style=\"top:188px; left:71px;\" src=\"/192/en/static/_content/45-sub-1.png\">\n        <img class=\"halfScale 45-title\" style=\"top:482px; left:71px;\" src=\"/192/en/static/_content/45-title-2.png\">\n        <img class=\"halfScale 45-sub\" style=\"top:541px; left:71px;\" src=\"/192/en/static/_content/45-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax();\n          pg45Anim.staggerFromTo(cOf(\"45-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"45-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg45Anim.stop();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  LIECHTENSTEIN  www.lfv.li  A NEW VISION IN PREPARATION In consultation with its seven affiliated clubs, the Liechtenstein Football Association (LFV) is drawing up a list of priorities for grassroots and elite football for the 2021–26 period. As part of a project entitled Vision Fussball Liechtenstein, a wide-ranging process has been launched to identify the measures required to enhance football in Liechtenstein. In 2018, the LFV began a series of discussions with its affiliated clubs in order to analyse in detail the current situation of Liechtenstein football. The results of this process were presented at an initial get-together last year. Following further feedback from the clubs, the focus was placed on the four areas of grassroots football, development, elite  football and women’s football. Working groups made up of club and LFV representatives have since been compiling a list of possible measures, which were presented at a recent meeting. The working groups’ proposals were strongly supported by the clubs, as a result of which new working groups will now be set up to work out the detail of the steps that need to be taken. “Cooperation with the clubs is extremely important for the LFV and forms the basis of its strategy for 2021–26, which aims to set out a strategic plan for football in Liechtenstein. We are supporting this process by placing the vision at the heart of our strategy,” said the LFV’s general secretary, Peter Jehle, who welcomed the results of the  LFV  FLORIAN HEPBERGER  project so far. Hugo Quaderer, LFV president, was delighted with the positive feedback received from the clubs: “The outcome that was mutually agreed at the meeting and backed by all the clubs forms, for all of us, the authoritative basis for the planning and implementation of the next steps of the process. The second part of the vision-casting project has already begun to deliver results.”  LUXEMBOURG  www.football.lu  STADE DE LUXEMBOURG READY BY THE END OF THE YEAR JOËL WOLFF  hybrid grass playing surface, 560 VIP seats, floodlighting with over 1700 lux and all the amenities, changing rooms, indoor spaces, spectator facilities and media areas required for a UEFA category 4 stadium.  The construction will cost €76.6 million, funded entirely by Luxembourg City and the state of Luxembourg. The FLF is looking forward to finally being able to use this new jewel in the crown of Luxembourg football.  FLF  The Luxembourg Football Federation (FLF) has decided to name its new national football ground the Stade de Luxembourg. The name was revealed during a recent visit to the venue by FLF officials, accompanied by the Luxembourg City mayor and the minister for sport. The new stadium, located in the south of Luxembourg City, is fitted with 9,386 seats in the national colours of red, white and blue. It is due to be finished by the end of this year and will stage its first match, a 2022 World Cup qualifier, next March. Built to replace the old Stade Josy Barthel, the Stade de Luxembourg will host national team and FLF games as well as UEFA competition matches played by Luxembourg clubs. Designed by German architectural group GMP and Luxembourg firm Beng, the stadium will be equipped with a  UEFA DIRECT • Q4 2020 – 45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 46-title\" style=\"top:152px; left:57px;\" src=\"/192/en/static/_content/46-title-1.png\">\n        <img class=\"halfScale 46-sub\" style=\"top:211px; left:57px;\" src=\"/192/en/static/_content/46-sub-1.png\">\n        <img class=\"halfScale 46-title\" style=\"top:529px; left:57px;\" src=\"/192/en/static/_content/46-title-2.png\">\n        <img class=\"halfScale 46-sub\" style=\"top:588px; left:57px;\" src=\"/192/en/static/_content/46-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg46Anim = new TimelineMax();\n          pg46Anim.staggerFromTo(cOf(\"46-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"46-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg46Anim.stop();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  MALTA  www.mfa.com.mt  GOOD GOVERNANCE AND SUSTAINABILITY AT THE CENTRE OF ONGOING REFORMS KEVIN AZZOPARDI  The Malta Football Association has launched an extensive governance reform process covering a number of important sectors, namely ethics and integrity, the association’s statutes, procurement, domestic club licensing and club corporate restructuring. These reforms are in sync with the development of a new four-year strategy for the association, which is expected to be published in the coming months. The Malta Football Association president, Bjorn Vassallo, stressed that the long-term sustainability of Maltese football lies at the heart of these reforms. “From day one of my term as president, the sustainability of the footballing sector has been a top priority for the association,” he said. “Sustainability revolves around two  pillars – good governance, based on best practices and higher standards, and financial stability, which relies on finding a positive balance between income and expenditure, along with long-term investment.” The reforms are being conducted by different committees, with Matthew Paris, one of the Malta FA vicepresidents, leading the entire process. The new Ethics and Integrity Committee is primarily focused on addressing any conduct that may tarnish the integrity and reputation of football, particularly illegal, immoral and unethical behaviour. The tasks and responsibilities of the Statutes Revision Committee, with the support of FIFA and UEFA, are to revise and modernise the Malta FA’s statutes and decision-making processes. The clubs’ status has been revised  NORTHERN IRELAND  based on the respective divisions, with clubs in the top tiers (Premier League and Challenge League) allowed to have a professional status, while the lower divisions of domestic football will be strictly amateur. The development of football plays an essential role in the wider development of the game for both men and women. The broadening of the licensing criteria represents a significant step in the development of the licensing system. This reform is intended to ensure fairer competitions, financial discipline and long-term stability. Club corporate restructuring entails the revision of regulations to reflect the requirements of modern football clubs. The plan is for Maltese clubs to be streamlined according to their licence and status, giving them the opportunity to become companies. www.irishfa.com  STEPHEN MARTIN AIMS TO ADVANCE FOOTBALL ACROSS NORTHERN IRELAND NIGEL TILSON  46 – UEFA DIRECT • Q4 2020  service of Northern Ireland following a successful police career spanning 34 years, Stephen Martin  IFA  The new chairman of the Irish Football Association Board, Stephen Martin, has promised to champion football at all levels across Northern Ireland. Stephen Martin was appointed as an independent non-executive director of the association in June and in August was unanimously appointed to the position of chairman of the Irish FA Board. He said: “I am delighted to be appointed to lead this ambitious and forward-looking board. I’ll be championing football at all levels for the advancement of the game right across Northern Ireland. As with all good teams, I look forward to playing my part in the Irish FA’s continued success.” Stephen Martin, who recently retired as acting deputy chief constable of the police  succeeds leading banker Gerry Mallon, who had held the position since 2015. The Irish FA president, David Martin, said: “We are delighted to have Stephen join the association. His skills and experience will be a real asset to our board.” The new chairman, who is a passionate Liverpool supporter, is a lifelong Northern Ireland fan. As a young boy, he cheered on the team from the South Stand at Windsor Park alongside his late father, uncle and cousin. He remembers attending many British Home Championship matches and the home qualifiers in the Spain ’82 and Mexico ’86 World Cup campaigns. He said: “That was a fabulous period for Northern Ireland and I’ll never forget it. However, we are in a great place again now and building on our success at EURO 2016.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 47-title\" style=\"top:152px; left:71px;\" src=\"/192/en/static/_content/47-title-1.png\">\n        <img class=\"halfScale 47-sub\" style=\"top:211px; left:71px;\" src=\"/192/en/static/_content/47-sub-1.png\">\n        <img class=\"halfScale 47-title\" style=\"top:482px; left:71px;\" src=\"/192/en/static/_content/47-title-2.png\">\n        <img class=\"halfScale 47-sub\" style=\"top:541px; left:71px;\" src=\"/192/en/static/_content/47-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax();\n          pg47Anim.staggerFromTo(cOf(\"47-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"47-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg47Anim.stop();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  REPUBLIC OF IRELAND  www.fai.ie  NEW COACH EDUCATION PATHWAY SHOWS WAY FORWARD GARETH MAHER  There has been an overwhelmingly positive reaction to the 2021–25 Football Association of Ireland (FAI) coach education pathway after it was launched in August. Building on the success of the 2017–20 pathway, the FAI coach education and high performance departments visited several countries, elicited feedback from hundreds of coaches and worked closely with UEFA to shape a new pathway that would be more inclusive and beneficial to all coaches. The unveiling of this pathway follows on the back of a popular weekly webinar series that has engaged with over 350,000 people, a regular digital newsletter and unprecedented growth  of the FAI coach education social media channels. Now, with courses having resumed following the COVID-19 lockdown period, the new pathway provides coaches – at all levels – with a clear direction. 2021–25 coach education pathway key points • Implementation of the changes to the UEFA Coaching Convention, including a formal coach educator qualification, specialist elite youth and goalkeeping licences, and introduction of the UEFA C licence. • Annual calendar of coaching conferences, including football  ROMANIA  fitness, female game, goalkeeping, Pro licence, national coaching conference and futsal. • Modular continuing professional development (CPD) process for football fitness and performance analysis, ensuring a competence level in each area before undertaking formal courses. • Introduction of the UEFA grassroots leader certificate as an elite coach qualification, allowing grassroots coaches to obtain a UEFA qualification. • New optional workshops, such as One Good Coach, which is a free online workshop, and Referee Intro, which will help coaches to better understand the Laws of the Game. www.frf.ro  FANS GET BEHIND THE NATIONAL TEAM FROM A VIRTUAL THREE-COLOURED STAND PAUL ZAHARIA  FRF  Mirel Rădoi has been at the helm of the Romanian men’s national team since November 2019, having previously taken the Under-21 national team into the semi-finals of the European Under-21 Championship in Italy and San Marino. Unfortunately, the coronavirus pandemic meant that the  senior national team had to wait almost ten months until their first official matches under their new coach – a 2020/21 UEFA Nations League home match against Northern Ireland on 4 September, followed by an away match in the same competition against Austria on 7 September. Romania’s EURO 2020 qualifying play-off semi-final against Iceland had been scheduled for 26 March but had to be postponed and is now set to take place on 8 October. It has been a challenging start, to say the least, for the new head coach and his staff, as well as a new start for the national team and its legions of loyal supporters. There is a special bond between the fans and their national team, as demonstrated by the more than 25,000 children who cheered on their favourites in the EURO 2020 qualifier played behind closed doors against Norway last October, proving that even if  Romania has to play without spectators, it will never be without fans. To keep that special bond alive at a time when the pandemic is stopping fans from physically standing side by side in the stadium, the Romanian FA (FRF) decided to set up a virtual three-coloured stand in the country’s colours of red, yellow and blue. By accessing the special three-coloured stand on the FRF’s official website, a Google map of the whole world is displayed on which fans can drag and drop a football on the region or country where they live. At the same time, they can leave a message for the players. The map and the messages received will accompany the team wherever they go, from a home training camp in Mogoșoaia, to the dressing room at the Bucharest National Arena and the stands at the home stadiums where Romania will play during the current UEFA Nations League campaign. UEFA DIRECT • Q4 2020 – 47"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 48-title\" style=\"top:152px; left:57px;\" src=\"/192/en/static/_content/48-title-1.png\">\n        <img class=\"halfScale 48-sub\" style=\"top:211px; left:57px;\" src=\"/192/en/static/_content/48-sub-1.png\">\n        <img class=\"halfScale 48-title\" style=\"top:542px; left:57px;\" src=\"/192/en/static/_content/48-title-2.png\">\n        <img class=\"halfScale 48-sub\" style=\"top:601px; left:57px;\" src=\"/192/en/static/_content/48-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim.staggerFromTo(cOf(\"48-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"48-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg48Anim.stop();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  RUSSIA  www.rfs.ru  FC CHERTANOVO MOSCOW TO PLAY IN THE UEFA YOUTH LEAGUE EKATERINA GRISHENKOVA  On 9 June, by decision of the executive committee of the Football Union of Russia (RFS), the debut season of the youth football league ended ahead of schedule. FC Chertanovo Moscow became the winners of the tournament interrupted by the COVID-19 pandemic, which gives them the opportunity to play in the UEFA Youth League this season. The youth football league is a project to reform the youth competition system in Russia, a new solution for the reserve preparation system. The league brings together the best young Russian players, helping them to develop in youth and then in professional football. In addition, it serves as the qualifying competition for the UEFA Youth League. In the first season, teams from 12 academies played in the league, consisting mainly of players born in 2002.  The league participants were selected by RFS experts on the basis of a consolidated rating of football schools, taking into account the results achieved in the Russian youth championship final tournaments, as well as representation in the Russian national teams. The youth football league involves teams from different regions of Russia: Spartak, CSKA, Lokomotiv, Dynamo, Chertanovo and Strogino (all Moscow), Zenit and SSHOR Zenit (both from St Petersburg), Krasnodar, Rubin Kazan, Master Saturn from the Moscow region and Konoplev Academy from the Samara region competed for the first trophy. The first season started on 2 August 2019 but came to a premature end on 15 March, after 15 matchdays, due to the spread of COVID-19 in Russia. Chertanovo, who were top of the table at that time, were recognised as the  winners. They had won 13 matches and drawn two, taking them to 41 points. Dynamo Moscow finished in second place, with FC Krasnodar third. Alexander Dyukov, president of the RFS, was pleased with the results of the debut youth football league season, in which almost 400 young players took part in the 90 matches held. The games were watched by football experts, including the Russian men’s national team head coach, Stanislav Cherchesov. The young footballers gained valuable experience and the opportunity to play with the strongest in their age group. “We created this championship to immerse the youngsters in a competitive environment. It’s too early to draw conclusions, but we saw the benefit and effectiveness. Some of the players have already joined the senior teams,” Dyukov said.  SLOVAKIA  www.futbalsfz.sk  CELEBRATING MILESTONE BIRTHDAYS AND MOURNING THE DEPARTED PETER SURIN  During the coronavirus pandemic, when the match carousel slowed down and the public fought with an invisible enemy, two prominent members of the Slovak football family celebrated their 70th birthdays. Up first, in March, was the captain of the 1976 European champions’ team, Anton Ondruš. The libero of the team, described as the Beckenbauer of the East, excelled in the air, with a great sense of positioning on the pitch. He was one of the key personalities of the winning team in 1976 and came in sixth in that year’s France Football Golden Ball poll, the best result ever of a Slovak player. After hanging up his boots, he settled in Thonon-les-Bains in France, 48 – UEFA DIRECT • Q4 2020  but stayed involved with Slovak football as manager of the national team and of Slovan Bratislava, where he also served as the club’s president for a year. He is a member of Slovak football’s Hall of Fame. In August, it was the turn of Marián Masný, Ondruš’ long-time teammate at both club and national team level. An exceptional winger, Masný played 345 league matches and scored 103 goals. With Slovan, where he spent 11 years, he won two championships and two domestic cups. He has two European championship medals – gold from 1976 and bronze from 1980 – and also played in the 1982 World Cup. He played 75 matches for the national team, holding the record of most-capped player for a long time, scoring 18 goals.  He finished ninth in the 1976 France Football poll. In a commentary on the 1976 European Championship finals, Jacques Ferran, a journalist and director of France Football magazine, wrote: “In the decisive match for the title, we saw a future world star – Masný.” Sadly, life also means death, and Slovak football has also recently mourned the loss of three important personalities: Marián Čišovský (41), former player with Inter Bratislava, Žilina, Petržalka, Timişoara and Viktoria Plzeň, who succumbed to motor neurone disease; and 1976 European champions Jaroslav Pollák (73) and Pavol Biroš (67), both after serious illness. The Slovak football family will never forget them."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 49-title\" style=\"top:152px; left:71px;\" src=\"/192/en/static/_content/49-title-1.png\">\n        <img class=\"halfScale 49-sub\" style=\"top:211px; left:71px;\" src=\"/192/en/static/_content/49-sub-1.png\">\n        <img class=\"halfScale 49-title\" style=\"top:505px; left:71px;\" src=\"/192/en/static/_content/49-title-2.png\">\n        <img class=\"halfScale 49-sub\" style=\"top:565px; left:71px;\" src=\"/192/en/static/_content/49-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg49Anim = new TimelineMax();\n          pg49Anim.staggerFromTo(cOf(\"49-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"49-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg49Anim.stop();\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  SWEDEN  www.svenskfotboll.se  BLACK SHORTS PUTS REYMERSHOLMS GIRLS AT EASE ANDREAS NILSSON  With the club motto being ‘For as many as possible, for as long as possible’, the board of Reymersholms IK saw the issue in the same way. “They presented us with a problem and a simple solution. It was an easy, three-minute decision to take at the board meeting,” said chairman Hans Förnestig. By summer, all Reymersholms girls’ teams had their black shorts ready and could focus fully on their football again. “I’m really happy that the board was flexible on the kit colours, and that they showed that our club can move with the times,” said Line Trondsen Hetteberg. SvFF  Inclusiveness, and making sure football is for everyone, can be done in many ways. One of them could be to adjust the colours of the team kit. Reymersholms IK from Stockholm was founded in 1899 and has played in the same colours ever since: green shirts, white shorts and green socks. But this spring, the club’s Under-14 girls petitioned the board to allow them to play with black shorts instead of white. As the girls approached puberty, many became uncomfortable with the white shorts – worried about period stains becoming visible through the thin white shorts. Some took to wearing warm-up pants or tights under the shorts, and some just declined to play games during their period.  “For me, the important thing is that the girls feel at ease when playing football. As adults, we have a responsibility to show the children that we listen to their concerns and then to make sound decisions,” said team manager Line Trondsen Hetteberg.  SWITZERLAND		  www.football.ch  FORMER NATIONAL TEAM COACH PAUL WOLFISBERG PASSES AWAY PIERRE BENOIT  enormously popular among players and fans alike. Thanks to this rekindling of public interest, the national team’s official fan club grew enormously during the Wolfisberg era. A friendly against Brazil attracted a crowd of 60,000 to Basel’s St. Jakob Park in 1983, two years after 40,000 fans watched a home victory over England, also in Basel. The Wankdorf stadium in Berne subsequently recorded attendances of 38,000 and 51,000 respectively for 1986 World Cup qualifiers against Denmark and the Soviet Union. The current Swiss FA president, Dominique Blanc, and Andy Egli, who played in defence for the Swiss national team during Wolfisberg’s reign, remember him with great fondness. “During the 1980s, Paul Wolfisberg put the Swiss national team back on the road to  success after a long dry spell,” said Blanc. “Down to earth, genuine and, at the same time, a consummate professional, he played his way into the hearts of the Swiss people. Swiss football is mourning a true great.” “This terrible news came as a huge shock for me,” said Egli, “because we had been sitting together at a birthday party only two days earlier. Wolfisberg was a great character and leader who, like Köbi Kuhn after him, gave his players a huge amount of freedom. He was both competent and witty, and he put his faith in young players, which worked in my favour. He knew how to fill us with confidence and his passing is a dreadful loss for Swiss football.” SFV-ASF  Nine months after the death of former national team coach Jakob ‘Köbi’ Kuhn, one of his predecessors, Paul Wolfisberg, passed away in his home town of Horw at the end of August, aged 87. Having won the Swiss Cup with FC Luzern as a player in 1960, Wolfisberg coached the club into the Nationalliga A in 1979 before leading the Swiss national team from 1981 to 1985 and again in 1989. Although he did not achieve any major successes or qualify for a EURO or World Cup finals, he managed to restore the Swiss national team’s somewhat tarnished image during his tenure. ‘The Wolf’ coached the national team for 52 matches, securing 17 victories along the way (as well as 20 draws and 15 defeats). Despite his relatively modest win rate, he was highly regarded in Switzerland and  UEFA DIRECT • Q4 2020 – 49"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 50-title\" style=\"top:152px; left:57px;\" src=\"/192/en/static/_content/50-title-1.png\">\n        <img class=\"halfScale 50-sub\" style=\"top:211px; left:57px;\" src=\"/192/en/static/_content/50-sub-1.png\">\n        <img class=\"halfScale 50-title\" style=\"top:529px; left:57px;\" src=\"/192/en/static/_content/50-title-2.png\">\n        <img class=\"halfScale 50-sub\" style=\"top:565px; left:57px;\" src=\"/192/en/static/_content/50-sub-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:650px;left:295px;width:40px;height:12px;\">\n          <a href=\"https://www.facebook.com/FAWales/videos/308529100501208/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:650px;left:376px;width:39px;height:12px;\">\n          <a href=\"https://www.youtube.com/watch?v=FQVW4UvD-wI\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg50Anim = new TimelineMax();\n          pg50Anim.staggerFromTo(cOf(\"50-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.6, 1)\n          .staggerFromTo(cOf(\"50-sub\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.6, 1.3)\n        }\n        function onPageLeave() {\n          pg50Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "MEMBER ASSOCIATIONS  UKRAINE  www.ffu.org.ua  VAR TRAINING FOR REFEREES AND CERTIFICATION OF INSTRUCTORS YURI MAZNYCHENKO  Volodymyr Rasner  The Ukrainian Association of Football has launched the second phase of training for video assistant referees (VAR). The match officials are now consolidating the knowledge acquired during the first phase of training.  At the same time, the referees committee of the association aims to increase its number of certified VAR instructors. This VAR training process started in July, when several stages (introduction, reviewing videos and analysis of complicated game situations) were completed. The second phase involves 14 referees, who will be allowed to officiate as VARs from November. During this second phase of training, the referees will practise in simulated situations and short friendly matches. The aim is also to produce certified domestic instructors who can  WALES  conduct similar training on their own in the future. Currently, there is only one VAR certified instructor in Ukraine, referees committee chairman Luciano Luci. “We have invited a FIFA specialist to train our referees, as well as to certify VAR instructors. Based on the results of their training, the referees’ knowledge and skills will be assessed, and once they are certified the association will be able to fully engage in the process of training officials to work with the video assistant system, without involving foreign experts,” Luciano Luci explained. Furthermore, the association plans to purchase equipment and a second VAR van to increase coverage of the Ukrainian premier league to four games per matchday (from two per matchday at present). www.faw.cymru  RYAN GIGGS: CYMRU To increase engagement with international fans prior to Cymru’s [Wales’] return to action in September, the Football Association of Wales (FAW) released an exclusive behind-the-scenes docuseries covering the first two years of Ryan Giggs’ time as the national team manager. The five-part documentary uses archive footage together with first-hand interviews from those in the heart of the action, including Ryan Giggs, senior players and backroom staff, all filmed by the FAW’s videography team, Tiny Welsh Media. Titled Ryan Giggs: Cymru, the series follows the ups and downs of managerial life, starting with Giggs’ appointment in January 2018, tracking Cymru’s journey across the world from China to Los Angeles, Cymru’s qualification journey to 50 – UEFA DIRECT • Q4 2020  EURO 2020, and ending with heartwarming videos of the Cymru manager’s impactful visits to junior football clubs and schools across Wales. The series was released publicly across the FAW’s Facebook page and YouTube channel, ensuring exclusive, instant access to the docuseries for members of The Red Wall, the FAW’s supporters’ club. The FAW also collected questions from The Red Wall via a private newsletter, which culminated in a Q&A between Ryan Giggs and the FAW’s head of communication, Ian Gwyn Hughes, reflecting on the documentary series and Ryan Giggs’ time as Cymru manager from his perspective. The Q&A was released the night before the Cymru men’s first international match since November 2019 to ensure further interest in the senior men’s national team ahead of matchweek.  FAW  MELISSA PALMER"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "FORTHCOMING EVENTS  MATCHES October 1 October UEFA Europa League: play-offs 7–13 October UEFA European Under-21 Championship: qualifying matches 8 October UEFA EURO 2020: play-offs 9–11 October, Barcelona UEFA Futsal Champions League: finals 10/11 October UEFA Nations League: matchday 3 13/14 October UEFA Nations League: matchday 4 20/21 October UEFA Champions League: group matches (matchday 1) 21–27 October UEFA Women's EURO: qualifying matches 22 October UEFA Europa League: group matches (matchday 1) 27/30 October UEFA Champions League: group matches (matchday 2) 29 October UEFA Europa League: group matches (matchday 2)  24/25 November UEFA Champions League: group matches (matchday 4) 24–29 November UEFA Futsal Champions League: preliminary round 25 November – 1 December UEFA Women's EURO: qualifying matches 26 November UEFA Europa League: group matches (matchday 4) December 1/2 December UEFA Champions League: group matches (matchday 5) 3 December UEFA Europa League: group matches (matchday 5) 6–9 December UEFA Futsal EURO: group matches 8/9 December UEFA Women's Champions League: round of 32 (first legs) 8/9 December UEFA Champions League: group matches (matchday 6) 10 December UEFA Europa League: group matches (matchday 6)  15/16 December UEFA Women's Champions League: round of 32 (return legs)  MEETINGS October 1 October, Geneva UEFA Champions League: group stage draw 2 October, Nyon UEFA Europa League: group stage draw 23 October, Nyon UEFA Under-19 Futsal EURO: qualifying draw November 26 November Youth and Amateur Football Committee December 3 December, Nyon UEFA Nations League: finals draw Executive Committee 7 December, Nyon UEFA Women's EURO: play-off draw Women’s World Cup: qualifying round draw 14 December, Nyon UEFA Champions League: round of 16 draw UEFA Europa League: round of 32 draw  November  NOTICES  2–11 November Futsal World Cup: European qualifying matches (play-offs)  • Fernando Gomes has been re-elected president of the Portuguese Football Federation for another four-year term.  UEFA Futsal EURO: qualifying round play-offs 3/4 November UEFA Champions League: group matches (matchday 3) UEFA Women's Champions League: first qualifying round 5 November UEFA Europa League: group matches (matchday 3) 12 November UEFA EURO 2020: play-offs 12–19 November UEFA European Under-21 Championship: qualifying matches 14/15 November UEFA Nations League: matchday 5 17/18 November UEFA Nations League: matchday 6 18–19 November UEFA Women's Champions League: second qualifying round  • Tomas Danilevičius has been re-elected president of the Lithuanian Football Federation for another four-year term. • Ari Lahti has been re-elected president of the Football Association of Finland for another four-year term. • Luis Rubiales has been re-elected president of the Royal Spanish Football Federation for another four-year term.  OBITUARIES Mircea Pascu, former president of the Romanian Football Federation, passed away at the age of 85 on 16 September. Within UEFA, he served as a member of the Club Competitions Committee (1984–92), Fair Play Committee (1992–98) and the Circle of Former Committee Members. Fino Fini, former national team doctor and long-standing director of the Italian Football Association’s Coverciano technical centre, also a member of the Circle of Former Commitee Members, passed away at the age of 92 on 16 September. He sat on the UEFA Technical Development Committee from 1976 to 1992  and the Medical Sub-Committee from 1980 to 1982. Lars-Åke Lagrell, former president of the Swedish Football Association, passed away at the age of 80 on 21 September. Within UEFA, he served on the Futsal Committee (1986–92) and the Club Competitions Committee (1992–2000); chairman (2000–07) and vice-chairman (2007–11) of the National Team Competitions Committee; and vice-chairman (2009–11) and co-opted member (2011–15) of the National Associations Committee. He too was a member of the Circle of Former Committee Members and was awarded the UEFA Order of Merit in Diamond in 2016.  UEFA DIRECT • Q4 2020 – 51"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-159440454-22',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NZMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQhR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJtY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tGyY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1499494568641e3a9e1a.js